import React from "react";
import { defineMessages } from "react-intl";
const messages = defineMessages({
  benefitError101: {
    id: "benefits_101",
    defaultMessage: "Enrolment is closed, you can check your coverage under Benefits Statement",
  },
  benefitError102: {
    id: "benefits_102",
    defaultMessage:
      "{extraValue-2} selection is linked with {extraValue-1} selection. You have selected an invalid plan for {extraValue-2}, reselect a valid plan.",
  },
  benefitError103: {
    id: "benefits_103",
    defaultMessage:
      "You need to select {extraValue} before you can Checkout or Save your selection",
  },
  benefitError104: {
    id: "benefits_104",
    defaultMessage:
      "You are not allowed to make Enrolment selection on behalf of employee as an impersonator",
  },
  benefitError105: {
    id: "benefits_105",
    defaultMessage: "You are not allowed to Checkout on behalf of employee as an impersonator",
  },
  benefitError106: {
    id: "benefits_106",
    defaultMessage: "Checkout is not enabled, contact CXA for help",
  },
  benefitError107: {
    id: "benefits_107",
    defaultMessage: "Benefits selection is not enabled, contact CXA for help",
  },
  benefitError108: {
    id: "benefits_108",
    defaultMessage: "You need to give consent before you can checkout Benefits selection",
  },
  benefitError109: {
    id: "benefits_109",
    defaultMessage: "Benefits selection is not enabled, contact CXA for help",
  },
  benefitError110: {
    id: "benefits_110",
    defaultMessage: "You have selected an Invalid plan for the {extraValue}, reselect a valid plan",
  },
  benefitError111: {
    id: "benefits_111",
    defaultMessage: "You have selected more than allowed members for this {extraValue}",
  },
  benefitError112: {
    id: "benefits_112",
    defaultMessage: "You need complete HDF before you can checkout Benefits selection",
  },
  benefitError113: {
    id: "benefits_113",
    defaultMessage:
      "Your sum assured amount for the {extraValue} doesn't match based on the interval selected, contact CXA for help",
  },
  benefitError114: {
    id: "benefits_114",
    defaultMessage:
      "You have selected ineligible member(s) for this {extraValue}, remove ineligible members to proceed with Checkout",
  },
  benefitError115: {
    id: "benefits_115",
    defaultMessage:
      "You have selected some members in the rider product ({extraValue-2}) who are not selected in the main product ({extraValue-1}). Remove these members from the rider product ({extraValue-2}).",
  },
  benefitError116: {
    id: "benefits_116",
    defaultMessage:
      "You have not selected any member(s) for this {extraValue}, select valid members to proceed with Checkout",
  },
  TWOFA_LOCKED: {
    id: "TWOFA_LOCKED",
    defaultMessage: "<p><strong>Your account is temporarily locked for 60 minutes as you have entered an invalid code more than 5 times.</strong></p><p><strong>Please try again later, or contact PPCXA Contact Centre for assistance.</strong></p>",
  },
  TWOFA_BLOCKED_RESEND: {
    id: "TWOFA_BLOCKED_RESEND",
    defaultMessage: "You have requested code to be resent more than 10 times. Please wait for an hour and try signing on again.",
  },
  hraDisclaimerText: {
    id: "hra-disclaimer-text",
    defaultMessage:
      "Any information you provide to CXA will be at your own risk. Please review CXA's privacy policies carefully.",
  },
  shopDisclaimerText: {
    id: "shop-disclaimer-text",
    defaultMessage:
      "You are living OCBC's website. OCBC Bank is not responsible for, or liable to any person with regards to, any aspect of services and offering on the CXA Wellness Platform",
  },
  uploadValidImageDescription: {
    id: "Please upload a valid image file",
    defaultMessage: "Please upload a valid image file",
  },
  uploadImageLimitationDescription: {
    id: "Please upload image file with size less than 2MB.",
    defaultMessage:
      "Please upload image file (JPG, JPEG, JFIF, PNG, HEIF, HEIC, PDF) with size less than 2MB.",
  },
  uploadInvalidFileDescription: {
    id: "You have uploaded an invalid file format.",
    defaultMessage: "You have uploaded an invalid file format.",
  },
  uploadImageOrPDFLimitationDescription: {
    id: "Please upload an image or PDF file with size less than 2MB.",
    defaultMessage: "Please upload an image or PDF file with size less than 2MB.",
  },
  invalidNumberDescription: {
    id: "Invalid number",
    defaultMessage: "Invalid number",
  },
  invalidPostalCodeDescription: {
    id: "Invalid postal code",
    defaultMessage: "Invalid postal code",
  },
  invalidAmountDescription: {
    id: "Invalid amount",
    defaultMessage: "Invalid amount",
  },
  resetTextDescription: {
    id: "Reset",
    defaultMessage: "Reset",
  },
  submitNewClaimDescription: {
    id: "Submit a New Claim",
    defaultMessage: "Submit a New Claim",
  },
  submitNewDonationDescription: {
    id: "Submit a New Donation",
    defaultMessage: "Submit a New Donation",
  },
  donationClaimNotes: {
    id: "config.donationClaimNotes",
    defaultMessage: "Donation foot note example",
  },
  selectItemToStartDescription: {
    id: "Select an item to start",
    defaultMessage: "Select an item to start",
  },
  selectItemToStartDonationDescription: {
    id: "Select an item to start submitting donations",
    defaultMessage: "Select an item to start submitting donations",
  },
  formSubmittedSuccessfullyDescription: {
    id: "{formLabel}: {claimId} is submitted successfully.",
    defaultMessage: "{formLabel}: {claimId} is submitted successfully.",
  },
  withDrawClaimFromDescription: {
    id: "withDrawClaimFromDescription",
    defaultMessage: "You are about to withdraw the Claim Form:{claimId} ",
  },
  isProcessedDescription: {
    id: "Proceed?",
    defaultMessage: "Proceed?",
  },
  okTextDescription: {
    id: "OK",
    defaultMessage: "OK",
  },
  pendingClaimsDescription: {
    id: "Pending Claims",
    defaultMessage: "Pending Claims",
  },
  pendingDonationsDescription: {
    id: "Pending Donations",
    defaultMessage: "Pending Donations",
  },
  fromReimbursementDescription: {
    id: "from reimbursement.",
    defaultMessage: "from reimbursement.",
  },
  noAccountsDescription: {
    id: "No accounts available.",
    defaultMessage: "No accounts available.",
  },
  backButtonDescription: {
    id: "Back",
    defaultMessage: "Back",
  },
  accountExhaustedDescription: {
    id: "You have exhausted all the accounts balance or not yet available for the selected claim.",
    defaultMessage:
      "You have exhausted all the accounts balance or not yet available for the selected claim.",
  },
  benefitPlanDescription: {
    id: "Benefit Plan",
    defaultMessage: "Benefit Plan",
  },
  ClaimItemTypeDescription: {
    id: "Claim Type",
    defaultMessage: "Claim Type",
  },
  taxableDescription: {
    id: "Taxable",
    defaultMessage: "Taxable",
  },
  nonTaxableDescription: {
    id: "Non-Taxable",
    defaultMessage: "Non-Taxable",
  },
  claimNotesForDisplayDescription: {
    id: "Taxability applies to non insurance claims only.",
    defaultMessage: "Taxability applies to non insurance claims only.",
  },
  claimAccountNotesForDisplayDescription: {
    id: "#CLAIM_ACCOUNT_NOTES#",
    defaultMessage: " ",
  },
  planYearDescription: {
    id: "Plan Year",
    defaultMessage: "Plan Year",
  },
  calendarYearDescription: {
    id: "Calendar Year",
    defaultMessage: "Calendar Year",
  },
  exportAllDescription: {
    id: "Export All",
    defaultMessage: "Export All",
  },
  noClaimsDescription: {
    id: "No Claims",
    defaultMessage: "No Claims",
  },
  claimsHistoryDescription: {
    id: "Claims History",
    defaultMessage: "Claims History",
  },
  donationHistoryDescription: {
    id: "Donations History",
    defaultMessage: "Donations History",
  },
  accountDescription: {
    id: "Account",
    defaultMessage: "Account",
  },
  newClaimDescription: {
    id: "New Claim",
    defaultMessage: "New Claim",
  },
  newDonationDescription: {
    id: "New Donation",
    defaultMessage: "New Donation",
  },
  donationIDDescription: {
    id: "Donation ID",
    defaultMessage: "Donation ID",
  },
  submitTextDescription: {
    id: "Submit",
    defaultMessage: "Submit",
  },
  saveTextDescription: {
    id: "Save",
    defaultMessage: "Save",
  },
  editDescription: {
    id: "Edit",
    defaultMessage: "Edit",
  },
  deleteDescription: {
    id: "Delete",
    defaultMessage: "Delete",
  },
  helpMenuDescription: {
    id: "Help",
    defaultMessage: "Help",
  },
  contactUsDescription: {
    id: "Contact Us",
    defaultMessage: "Contact Us",
  },
  loginDescription: {
    id: "Log In",
    defaultMessage: "Log In",
  },
  consentTextDescription: {
    id: "I Consent",
    defaultMessage: "I Consent",
  },
  logoutTextDescription: {
    id: "Logout",
    defaultMessage: "Logout",
  },
  endInDescription: {
    id: "Enrolment ends in",
    defaultMessage: "Enrolment ends in",
  },
  startShoppingDescription: {
    id: "Start Shopping",
    defaultMessage: "Start Shopping",
  },
  learnMoreDescription: {
    id: "Learn More",
    defaultMessage: "Learn more",
  },
  dateRangeConnectorDescription: {
    id: "to",
    defaultMessage: "to",
  },
  noClaimDescription: {
    id: "You have not made any claims.",
    defaultMessage: "You have not made any claims.",
  },
  passwordExpireDescription: {
    id: "Password_Expire",
    defaultMessage: "Your password will expire in {passwordExpireInDays} days.",
  },
  changePasswordNowDescription: {
    id: "Change your password now",
    defaultMessage: "Change your password now",
  },
  completeDeclarationDescription: {
    id:
      "Please complete the health declaration form required for the Insurance Benefits Enrolment.",
    defaultMessage:
      "Please complete the health declaration form required for the Insurance Benefits Enrolment.",
  },
  introduceACMEDateDescription: {
    id: "Introducing ACME Benefits Programme",
    defaultMessage: "Introducing ACME Benefits Programme",
  },
  claimsDescription: {
    id: "Claims",
    defaultMessage: "Claims",
  },
  benefitsDescription: {
    id: "Benefits",
    defaultMessage: "Benefits",
  },
  claims: {
    submitClaimDescription: {
      id: "claims.submitClaimDescription",
      defaultMessage: "Submit a Claim",
    },
    statusDescription: {
      id: "claims.statusDescription",
      defaultMessage: "Claims Status",
    },
    noteDescription: {
      id: "claims.noteDescription",
      defaultMessage: "Note",
    },
    claimViewDescription: {
      id: "claims.claimViewDescription",
      defaultMessage: "Claims that have already been processed can be viewed under",
    },
    donationViewDescription: {
      id: "claims.donationViewDescription",
      defaultMessage: "Donations that have already been processed can be viewed under",
    },
    donationDescription:{
      id: "Donation",
      defaultMessage: "Donation",
    },
    claimDescription:{
      id: "Claim",
      defaultMessage: "Claim",
    },
    savedDescription:{
      id: "saved",
      defaultMessage: "saved",
    },
    submittedDescription:{
      id: "submitted",
      defaultMessage: "submitted",
    },
    successfullyDescription:{
      id: "successfully",
      defaultMessage: "successfully",
    },
    claimSubmittedStatusDescription: {
      id: "claims.claimSubmittedStatusDescription",
      defaultMessage:
        "If you want to check a submitted insurance claim status, please choose on the claim types below",
    },
    insurerClaimSubmittedStatusDescription: {
      id: "claims.insurerClaimSubmittedStatusDescription",
      defaultMessage:
        "You can check the status of claims submitted directly through insurer by clicking the link below",
    },
    claimSubmittedStatusNote: {
      id: "claims.claimSubmittedStatusNote",
      defaultMessage: "You will be redirected to the insurer page",
    },
    cpfDescription: {
      id: "claims.cpfDescription",
      defaultMessage: "CPF",
    },
    externalClaimConfirmation: {
      id: "claims.externalClaimConfirmation",
      defaultMessage:
        "You are now leaving Pacific Prime CXA website and entering a third party site. Would you like to continue?",
    },
    submitClaimFor: {
      id: "claims.submitClaimFor",
      defaultMessage: "Submit a Claim for",
    },
    submitClaimForInstruction: {
      id: "claims.submitClaimForInstruction",
      defaultMessage: "You can submit claims for yourself or on behalf of your delegator",
    },
    trackClaimFor: {
      id: "claims.trackClaimFor",
      defaultMessage: "Claims related to",
    },
    trackClaimForInstruction: {
      id: "claims.trackClaimForInstruction",
      defaultMessage: "You can track claims for yourself or on behalf of your delegator",
    },
    viewClaimsFor: {
      id: "claims.viewClaimsFor",
      defaultMessage: "View Claims for",
    },
    pendingClaimsEstimatedPaymentDate: {
      id: "claims.pendingClaimsEstimatedPaymentDate",
      defaultMessage: " ",
    },
    historyClaimsEstimatedPaymentDate: {
      id: "claims.historyClaimsEstimatedPaymentDate",
      defaultMessage: " ",
    },
    claimSubmissionSteps: {
      step1: {
        id: "claimSubmissionStepper.step1",
        defaultMessage: "Select Claim Type",
      },
      step2: {
        id: "claimSubmissionStepper.step2",
        defaultMessage: "Add Receipt",
      },
      step3: {
        id: "claimSubmissionStepper.step3",
        defaultMessage: "Add Supporting Documents",
      },
      step4: {
        id: "claimSubmissionStepper.step4",
        defaultMessage: "Review Claim",
      },
    },
    selectClaimType: {
      id: "claims.selectClaimType",
      defaultMessage: "Select Claim Type",
    },
    yourAccountBalance: {
      id: "claims.yourAccountBalance",
      defaultMessage: "Your Account Balance",
    },
    pointsToConsider: {
      id: "claims.pointsToConsider",
      defaultMessage: "Points to consider",
    },
    selectTheTypeOfClaim: {
      id: "claims.selectTheTypeOfClaim",
      defaultMessage: "Select the type of claim",
    },
    selectSpecificClaimType: {
      id: "claims.selectSpecificClaimType",
      defaultMessage: "Select a specific claim type",
    },
    planYears: {
      id: "claims.planYears",
      defaultMessage: "Plan year",
    },
    claimants: {
      id: "claims.claimants",
      defaultMessage: "Claimant name",
    },
    taxable: {
      id: "claims.taxable",
      defaultMessage: "Taxable",
    },
    cpfContributable: {
      id: "claims.cpfContributable",
      defaultMessage: "CPF Contributable",
    },
    proceed: {
      id: "claims.proceed",
      defaultMessage: "Proceed",
    },
    accounts: {
      period: {
        id: "claims.accounts.period",
        defaultMessage: "Period",
      },
      allocation: {
        id: "claims.accounts.allocation",
        defaultMessage: "Allocation",
      },
      utilized: {
        id: "claims.accounts.utilized",
        defaultMessage: "Utilized",
      },
      balance: {
        id: "claims.accounts.balance",
        defaultMessage: "Balance",
      },
      pendingReceiptAmount: {
        id: "claims.accounts.pendingReceiptAmount",
        defaultMessage: "Pending",
      },
    },
    addReceipt: {
      id: "claims.addReceipt",
      defaultMessage: "Add Receipt",
    },
    claimSubmissionGuideline: {
      id: "claims.claimSubmissionGuideline",
      defaultMessage: "Guidelines for claim submission",
    },
    uploadReceiptGuideline: {
      id: "claims.uploadReceiptGuideline",
      defaultMessage: "Guidelines to upload receipt file",
    },
    receiptProcessLongMsg1: {
      id: "claims.receiptProcessLongMsg1",
      defaultMessage: "Thanks for waiting!",
    },
    receiptProcessLongMsg2: {
      id: "claims.receiptProcessLongMsg2",
      defaultMessage:
        "Unfortunately we cannot process your file, this is taking longer than usual to process your file.",
    },
    receiptProcessLongMsg3: {
      id: "claims.receiptProcessLongMsg3",
      defaultMessage: "You may continue to fill-in the claims information manually.",
    },
    receiptProcessLoadMsg: {
      id: "claims.receiptProcessLoadMsg",
      defaultMessage: "Please wait we are processing your file",
    },
    manualUploadReceipt: {
      id: "claims.manualUploadReceipt",
      defaultMessage: "Do it yourself",
    },
    goPrevious: {
      id: "claims.goPrevious",
      defaultMessage: "Previous",
    },
    saveDraftClaim: {
      id: "claims.saveDraftClaim",
      defaultMessage: "Verify Claim Information",
    },
    dragAndDrop: {
      id: "claims.dragAndDrop",
      defaultMessage: "Drag and Drop",
    },
    yourFileDescription: {
      id: "claims.yourFileDescription",
      defaultMessage: "your file here",
    },
    uploadReceiptDescription: {
      id: "claims.uploadReceiptDescription",
      defaultMessage: "At least one file must be submitted to continue",
    },
    uploadFileDescription: {
      id: "claims.uploadFileDescription",
      defaultMessage: "Upload File",
    },
    uploadReceiptTips: {
      id: "claims.uploadReceiptTips",
      defaultMessage: "File size up to 2 MB",
    },
    addDocumentsDescription: {
      id: "claims.addDocumentsDescription",
      defaultMessage: "Supporting documents",
    },
    addDocumentsGuideline: {
      id: "claims.addDocumentsGuideline",
      defaultMessage: "Guidelines to add referral and supporting documents",
    },
    referralAndSupportingDocumentsGuideline: {
      id: "claims.referralAndSupportingDocumentsGuideline",
      defaultMessage: "Guidelines for submitting referral and supporting documents",
    },
    receipts: {
      id: "claims.receipts",
      defaultMessage: "Receipts",
    },
    referralDocument: {
      id: "claims.referralDocument",
      defaultMessage: "Referral document",
    },
    supportingDocuments: {
      id: "claims.supportingDocuments",
      defaultMessage: "Supporting documents",
    },
    previewButton: {
      id: "claims.previewButton",
      defaultMessage: "Preview",
    },
    reviewClaimDescription: {
      id: "claims.reviewClaimDescription",
      defaultMessage: "Review Claim",
    },
    claimDetailDescription: {
      id: "claims.claimDetailDescription",
      defaultMessage: "Claim Detail",
    },
    claimDecision: {
      id: "claims.claimDecision",
      defaultMessage: "Decision :",
    },
    rejectReason: {
      id: "claims.rejectReason",
      defaultMessage: "Reject Reason :",
    },
    rejectDescription: {
      id: "claim.rejectDescription",
      defaultMessage: "Do you confirm to reject this claim? This action cannot be undone.",
    },
    approve: {
      id: "claims.approve",
      defaultMessage: "Approve",
    },
    approveDescription: {
      id: "claim.approveDescription",
      defaultMessage: "Do you confirm to approve this claim? Once approved, this action cannot be undone. Please review the details before proceeding.",
    },
    reject: {
      id: "claims.reject",
      defaultMessage: "Reject",
    },
    claimSuccessfulMessage: {
      id: "claims.claimSuccessfulMessage",
      defaultMessage: "Claim ID ##id## has been submitted successfully.",
    },
    claimSuccessfulInstruction: {
      id: "claims.claimSuccessfulInstruction",
      defaultMessage:
        "You can track your claim status or Edit claim information under Track claims page.",
    },
    submitAnotherClaim: {
      id: "claims.submitAnotherClaim",
      defaultMessage: "Submit another claim",
    },
    noClinicsFoundDescription: {
      id: "claims.noClinicsFoundDescription",
      defaultMessage: "No nearby clinic",
    },
    noClinicsFoundByPostalCodeDescription: {
      id: "claims.noClinicsFoundByPostalCodeDescription",
      defaultMessage: "No clinics found on ",
    },
    clinicsProviderFilter: {
      id: "clinic.allClinics",
      defaultMessage: { value: "All", label: "All Clinics" },
    },
    clinicsAddressPlaceholder: {
      id: "clinic.searchByLocation",
      defaultMessage: "Search by location or postal code",
    },
    clinicsNamePlaceholder: {
      id: "clinic.searchByClinicName",
      defaultMessage: "Search by clinic name",
    },
    trackMyClaim: {
      id: "claims.trackMyClaim",
      defaultMessage: "Track my claim",
    },
    filterDescription: {
      id: "claims.filterDescription",
      defaultMessage: "Filter",
    },
    pendingClaimsDescription: {
      id: "claims.pendingClaimsDescription",
      defaultMessage: "Pending Claims",
    },
    eCardsDescription: {
      id: "general.ecards",
      defaultMessage: "eCards",
    },
    eCardsDownloadDescription: {
      id: "claims.eCardsDownloadDescription",
      defaultMessage: "Download",
    },
    eCardsTitleDisclaimer: {
      id: "ecards.disclaimer",
      defaultMessage: "Disclaimer",
    },
    eCardsShareDisclaimer: {
      id: "ecards.share.disclaimer",
      defaultMessage: "The medical e-card contains personal information such as Name, IC, etc. By sharing this information through third-party applications like WhatsApp, Gmail, Skype, etc., you acknowledge that you understand the implications under Singapore's Personal Data Protection Act (PDPA) and other relevant law and regulations.\n\nYou are responsible for ensuring the security and confidentiality of the shared data. Please verify that the recipient is trusted and that they understand the importance of protecting this information.\n\nBy proceeding, you accept full responsibility for any potential data breaches or misuse that may occur as a result of sharing this information through non-secure channels. Our organization is not liable for any loss or damage arising from the transmission of personal data via these third-party platforms.",
    },
    eCardsShowClinic: {
      id: "ecards.showClinics",
      defaultMessage: "Show Clinics",
    },
    noECardsFoundDescription: {
      id: "claims.noECardsFoundDescription",
      defaultMessage: "No eCards found",
    },
    eCardsProviderFilter: {
      id: "ecards.allCards",
      defaultMessage: { value: "All", label: "All Cards" },
    },
    eCardsMemberFilter: {
      id: "ecards.allMembers",
      defaultMessage: { value: "All", label: "All Members" },
    },
    noImageECardsDownload: {
      id: "claims.noImageECardsDownload",
      defaultMessage: "No images available for download.",
    },
    allClaimsDescription: {
      id: "claims.allClaimsDescription",
      defaultMessage: "All Claims",
    },
    processedClaimsDescription: {
      id: "claims.processedClaimsDescription",
      defaultMessage: "Processed Claims",
    },
    expenseClaimsDescription: {
      id: "claims.expenseClaimsDescription",
      defaultMessage: "Expense Claims",
    },
    insuranceGHSClaimsDescription: {
      id: "claims.insuranceGHSClaimsDescription",
      defaultMessage: "Insurance GHS Claims",
    },
    InsuranceOutpatientClaimsDescription: {
      id: "claims.InsuranceOutpatientClaimsDescription",
      defaultMessage: "Insurance Outpatient Claims",
    },
    flexClaimsDescription: {
      id: "claims.flexClaimsDescription",
      defaultMessage: "Flex Claims",
    },
    noRecordsFoundDescription: {
      id: "claims.noRecordsFoundDescription",
      defaultMessage: "No records found",
    },
    moreInformationRequiredDescription: {
      id: "claims.moreInformationRequiredDescription",
      defaultMessage: "More information required",
    },
    saveClaimInformationDescription: {
      id: "claims.saveClaimInformationDescription",
      defaultMessage:
        "Please note that if you leave this page now, your claims information won't be saved.",
    },
    saveDraftClaimInformationDescription: {
      id: "claims.saveDraftClaimInformationDescription",
      defaultMessage:
        "Please note that if you leave this page now, your claims information will not be submitted or processed. It will be saved as \"Draft\", excluding any changes made on this page. You can edit and submit the claim before it expires on {expiredDate} from the Track claim page.",
    },
    helpText: {
      claimant: {
        id: "claims.helpText.claimant",
        defaultMessage: "",
      },
      provider: {
        id: "claims.helpText.provider",
        defaultMessage: "Enter the service provider or clinic name",
      },
      receiptNo: {
        id: "claims.helpText.receiptNo",
        defaultMessage: "Enter the bill number or invoice number",
      },
      receiptDate: {
        id: "claims.helpText.receiptDate",
        defaultMessage: "Enter the billing date or invoice date",
      },
      receiptAmount: {
        id: "claims.helpText.receiptAmount",
        defaultMessage: "Enter the total amount paid",
      },
      claimReason: {
        id: "claims.helpText.claimReason",
        defaultMessage: "Select the clinic diagnosis as stated by your doctor",
      },
    },
    capturePhotoDescription: {
      id: "claims.capturePhotoDescription",
      defaultMessage: "Capture Photo",
    },
    stopCaptureDescription: {
      id: "claims.stopCaptureDescription",
      defaultMessage: "Stop Capture",
    },
    savePhotoDescription: {
      id: "claims.savePhotoDescription",
      defaultMessage: "Save Photo",
    },
    retakePhotoDescription: {
      id: "claims.retakePhotoDescription",
      defaultMessage: "Retake Photo",
    },
    reachLimitErrorDescription: {
      id: "claims.reachLimitErrorDescription",
      defaultMessage: "You can't submit this claim as you have reached the maximum limit for this type of claim for the Plan year.",
    },
  },
  submitClaimDescription: {
    id: "Submit Claim",
    defaultMessage: "Submit Claim",
  },
  viewClaimsOverviewDescription: {
    id: "View Claims",
    defaultMessage: "View Claims",
  },
  shopDescription: {
    id: "Shop",
    defaultMessage: "Shop",
  },
  visitWellnessShopDescription: {
    id: "Visit Wellness Shop",
    defaultMessage: "Visit Wellness Shop",
  },
  sendCxaAppDownloadLinkDescription: {
    id: "Send CXA App Download Link",
    defaultMessage: "Send CXA App Download Link",
  },
  enterMobileNumberDescription: {
    id: "Enter Mobile Number",
    defaultMessage: "Enter Mobile Number",
  },
  mobileAppinfoDescription: {
    id: "mobile app info",
    defaultMessage:
      "This information will not be recorded by {companyName}. It will be forwarded to {linkProviderName} for app download purposes.",
  },
  viewAllDescription: {
    id: "View all",
    defaultMessage: "View all",
  },
  companyDescription: {
    id: "CXA Group",
    defaultMessage: "CXA Group",
  },
  appLinkProviderDescription: {
    id: "Link Provider",
    defaultMessage: "Branch.io",
  },
  appLinkProviderLinDescription: {
    id: "Link Provider Link",
    defaultMessage: "View {providerName} Privacy Policy",
  },
  reviewNowDescription: {
    id: "Review Now",
    defaultMessage: "Review Now",
  },
  faceAgingDescription: {
    id: "Do a Health Assessment Age Your Face Now",
    defaultMessage: "Do a Health Assessment Age Your Face Now",
  },
  healthReviewDashboardDescription: {
    id: "#Health_Review_Dashboard#",
    defaultMessage: "Health Review",
  },
  healthReviewHraResultsDescription: {
    id: "#Health_Review_HRA_Results#",
    defaultMessage: "Health Review",
  },
  messageBoardDescription: {
    id: "Message Board",
    defaultMessage: "Message Board",
  },
  claimActionDescription: {
    id: "Claim Action",
    defaultMessage: "We require additional documents and/or information for your Claim.",
  },
  reminderResetPass: {
    id: "action.resetPasswordTitle",
    defaultMessage: "Reminder to Reset your Password",
  },
  addSpouseTitle: {
    id: "action.addSpouseTitle",
    defaultMessage: "Addition Of Spouse",
  },
  passwordExpiry: {
    id: "config.action.passwordExpiryDate",
    defaultMessage: "Your password will expire in [PasswordExpireDays] days. To avoid any disruption, please update your password before it expires."
  },
  missingInfo: {
    id: "action.missingInfo",
    defaultMessage: "Missing information: Update your [MissingFields].\r\nThis information will be used to get your access back to the portal, in case if you can't access your primary email address."
  },
  pendingReview: {
    id: "action.pendingReview",
    defaultMessage: "You have pending expense claim to review for:"
  },
  additionOfSpouse: {
    id: "config.action.additionOfSpouse",
    defaultMessage: "Your request to add your spouse to the system has been successfully processed. Please review the details and ensure all information is correct."
  },
  claimIdDescription: {
    id: "Claim Id",
    defaultMessage: "Claim ID:",
  },
  claimItemDescription: {
    id: "Claim Item",
    defaultMessage: "Claim Item:",
  },
  claimButtonDescription: {
    id: "Claim Button Action",
    defaultMessage: "Submit Claim Documents",
  },
  benefitsEnrollmentActionDescription: {
    id: "Benefits Enrolment Action",
    defaultMessage: "You can now select your benefits until",
  },
  benefitsEnrollmentButtonDescription: {
    id: "Benefits Enrollment Button",
    defaultMessage: "Select Benefits",
  },
  HDFActionDescription: {
    id: "HDF Enrolment Action",
    defaultMessage: "You have to complete Health Declaration Form by",
  },
  HDFActionEnrollmentClosedDescription: {
    id: "HDF Enrolment Action Closed",
    defaultMessage: "Please complete the required Health Declaration Form.",
  },
  HDFFailedToCompleteEnrolmentDescription: {
    id: "HDF Failed Enrolment Action",
    defaultMessage:
      "Failing to complete Health declaration, your selection will be reverted to Default coverage",
  },
  HDFButtonDescription: {
    id: "HDF Enrollment Button",
    defaultMessage: "Complete Health Declaration",
  },
  actionsDescription: {
    id: "Actions Description",
    defaultMessage: "Actions",
  },
  noPendingActionsDescription: {
    id: "No Pending Actions Description",
    defaultMessage: "No Pending Actions",
  },
  countdownText : {
    id: "countdownText",
    defaultMessage: "{days} days {hours} hours and {minutes} minutes left",
    values: {
      days: "0",
      hours: "0",
      minutes: "0",
    },
  },
  visitEVouchersDescription: {
    id: "Visit eVouchers",
    defaultMessage: "Visit eVouchers",
  },
  noVochersDescription: {
    id: "no eVouchers",
    defaultMessage: "no eVouchers",
  },
  byDescription: {
    id: "by",
    defaultMessage: "by",
  },
  byValueDescription: {
    id: "by {value0}",
    defaultMessage: "by {value0}",
  },
  suggestedOffersDescription: {
    id: "Suggested Offers",
    defaultMessage: "Suggested Offers",
  },
  recommendedForYouDescription: {
    id: "Recommended For You",
    defaultMessage: "Recommended For You",
  },
  requiredDescription: {
    id: "Required",
    defaultMessage: "Required",
  },
  addDependatTextDescription: {
    id: "Add Dependant",
    defaultMessage: "Add Dependant",
  },
  editDependantTextDescription: {
    id: "Edit Dependant",
    defaultMessage: "Edit Dependant",
  },
  addTextDescription: {
    id: "Add",
    defaultMessage: "Add",
  },
  cancelTextDescription: {
    id: "Cancel",
    defaultMessage: "Cancel",
  },
  sortSuggestedDescription: {
    id: "Suggested for you",
    defaultMessage: "Suggested for you",
  },
  sortMostRecentDescription: {
    id: "Most Recent",
    defaultMessage: "Most Recent",
  },
  searchTextDescription: {
    id: "Search",
    defaultMessage: "Search",
  },
  filterByTopicDescription: {
    id: "Filter by Topic",
    defaultMessage: "Filter by Topic",
  },
  showingAllTextDescription: {
    id: "wellnessShop:showingAllResults",
    defaultMessage:
      "Showing {total, plural, =0 {# results} one {# result} other {all # results}}  {moreDescription, plural, =0 {} other {by {filters}}}",
  },
  wellnessShop_filterCategory: {
    id: "wellnessShop:filterCategory",
    defaultMessage: "{countCategories, plural, one {one category} other {[#] categories}}",
  },
  wellnessShop_filterPriceRange: {
    id: "wellnessShop:filterPriceRange",
    defaultMessage: "[{price}] price range",
  },
  noDocDescription: {
    id: "No documents.",
    defaultMessage: "No documents.",
  },
  benefitDocDescription: {
    id: "Benefits Documents",
    defaultMessage: "Benefits Documents",
  },
  purchaseDateDescription: {
    id: "Purchase Date",
    defaultMessage: "Purchase Date",
  },
  orderIdDescription: {
    id: "Order ID#",
    defaultMessage: "Order ID#",
  },
  orderDetailsDescription: {
    id: "Order Details",
    defaultMessage: "Order Details",
  },
  amountDescription: {
    id: "Amount",
    defaultMessage: "Amount",
  },
  accountOwnerDescription: {
    id: "Account Owner",
    defaultMessage: "Account Owner",
  },
  statusDescription: {
    id: "Status",
    defaultMessage: "Status",
  },
  voucherExpiredDescription: {
    id: "Voucher Expired",
    defaultMessage: "Voucher Expired",
  },
  resendVoucherDescription: {
    id: "Resend Voucher",
    defaultMessage: "Resend Voucher",
  },
  resendEmailDescription: {
    id: "Resend Email",
    defaultMessage: "Resend Email",
  },
  emailSentDescription: {
    id: "Email Sent!",
    defaultMessage: "Email Sent!",
  },
  succeedSignedUpDescription: {
    id: "Successfully signed up! Please login...",
    defaultMessage: "Successfully signed up! Please login...",
  },
  downloadVoucherDescription: {
    id: "Download Voucher",
    defaultMessage: "Download Voucher",
  },
  noDataDescription: {
    id: "No data",
    defaultMessage: "No data",
  },
  NumDescription: {
    id: "No.",
    defaultMessage: "No.",
  },
  myPurchasesDescription: {
    id: "My Purchases",
    defaultMessage: "My Purchases",
  },
  periodDescription: {
    id: "Period",
    defaultMessage: "Period",
  },
  employeeIdDescription: {
    id: "Employee ID",
    defaultMessage: "Employee ID",
  },
  nameDescription: {
    id: "Name:",
    defaultMessage: "Name:",
  },
  summaryDescription: {
    id: "Summary",
    defaultMessage: "Summary",
  },
  entitlementDescription: {
    id: "Entitlement",
    defaultMessage: "Entitlement",
  },
  utilisationDescription: {
    id: "Utilisation",
    defaultMessage: "Utilisation",
  },
  utilisedDescription: {
    id: "Utilised",
    defaultMessage: "Utilised",
  },
  benefitSelectionDescription: {
    id: "Benefits Enrolment",
    defaultMessage: "Benefits Selection",
  },
  benefitAdjustmentDescription: {
    id: "Benefits Enrolment Adjustment",
    defaultMessage: "Benefits Adjustment",
  },
  HAWPDescription: {
    id: "health And Wellness Purchase",
    defaultMessage: "Health And Wellness Purchase",
  },
  claimReimbursementDescription: {
    id: "Claim Reimbursement",
    defaultMessage: "Claim Reimbursement",
  },
  claimReimbursementTextDescription: {
    id: "CLAIM_REIMBURSEMENT_AMOUNT_TITLE",
    defaultMessage: "Reimbursement",
  },
  claimAccountsTextDescription: {
    id: "CLAIM_REIMBURSEMENT_ACCOUNT_TITLE",
    defaultMessage: "Accounts",
  },
  pendingAmountDescription: {
    id: "Pending Amount",
    defaultMessage: "Pending Amount",
  },
  balanceDescription: {
    id: "Balance",
    defaultMessage: "Balance",
  },
  transactionDetailsDescription: {
    id: "Transaction Details",
    defaultMessage: "Transaction Details",
  },
  transactionDescription: {
    id: "Transaction",
    defaultMessage: "Transaction",
  },
  categoryDescription: {
    id: "Category",
    defaultMessage: "Category",
  },
  transactedOnDescription: {
    id: "Transacted On",
    defaultMessage: "Transacted On",
  },
  effectiveOnDescription: {
    id: "Effective On",
    defaultMessage: "Effective On",
  },
  statementTextDescription: {
    id: "Statement",
    defaultMessage: "Statement",
  },
  employeeNameDescription: {
    id: "Employee Name",
    defaultMessage: "Employee Name",
  },
  statementDateDescription: {
    id: "Statement Date",
    defaultMessage: "Statement Date",
  },
  benefitsOverviewDescription: {
    id: "Benefits Overview",
    defaultMessage: "Benefits Overview",
  },
  benefitsStatementDescription: {
    id: "Benefits Statement",
    defaultMessage: "Benefits Statement",
  },
  pendingEnrolmentConfDescription: {
    id: "Pending your Enrolment Confirmation",
    defaultMessage: "Pending your Enrolment Confirmation",
  },
  HDFDescription: {
    id: "Health Declaration Form",
    defaultMessage: "Health Declaration Form",
  },
  noCoverageDescription: {
    id: "No Coverage",
    defaultMessage: "No Coverage",
  },
  filterNoCoverage: {
    id: "No Coverage",
    defaultMessage: "No Coverage",
  },
  filterNone: {
    id: "None",
    defaultMessage: "None",
  },
  filterInclude: {
    id: "Include",
    defaultMessage: "Include",
  },
  filterPrivate: {
    id: "Private",
    defaultMessage: "Private",
  },
  filterRestructured: {
    id: "Restructured",
    defaultMessage: "Restructured",
  },
  filterPublic: {
    id: "Public",
    defaultMessage: "Public",
  },
  optionTextDescription: {
    id: "Option:",
    defaultMessage: "Option:",
  },
  riskAndMedicalDescription: {
    id: "Risk & Medical",
    defaultMessage: "Risk & Medical",
  },
  productDescription: {
    id: "Product",
    defaultMessage: "Product",
  },
  descriptionDescription: {
    id: "Description",
    defaultMessage: "Description",
  },
  priceDescription: {
    id: "Price",
    defaultMessage: "Price",
  },
  healthAndWellnessDescription: {
    id: "Health & Wellness",
    defaultMessage: "Health & Wellness",
  },
  reviewCartDescription: {
    id: "Review your Cart",
    defaultMessage: "Review your Cart",
  },
  payrollDeuctionDescription: {
    id: "Payroll Deduction",
    defaultMessage: "Payroll Deduction",
  },
  notesDescription: {
    id: "Notes:",
    defaultMessage: "Notes:",
  },
  noteDescription: {
    id: "<b>Note:</b>",
    defaultMessage: "<b>Note:</b>",
  },
  notesContentDescription: {
    id: "You will not be allowed to make amendments to your selection/purchase after checking out.",
    defaultMessage:
      "You will not be allowed to make amendments to your selection/purchase after checking out.",
  },
  exceededDescription: {
    id: "You have exceeded available Flex Points",
    defaultMessage: "You have exceeded available Flex Points.",
  },
  reviseBothDescription: {
    id: "Please revise your Enrolment / Wellness Purchase before you can Confirm the check out",
    defaultMessage:
      "Please revise your Enrolment / Wellness Purchase before you can Confirm the check out.",
  },
  reviseEnrollmentDescription: {
    id: "Please revise your Enrolment Purchase before you can Confirm the check out.",
    defaultMessage: "Please revise your Enrolment Purchase before you can Confirm the check out.",
  },
  reviseWellnessDescription: {
    id: "Please revise your Wellness Purchase before you can Confirm the check out.",
    defaultMessage: "Please revise your Wellness Purchase before you can Confirm the check out.",
  },
  checkOutBenefitsDescription: {
    id: "Check Out",
    defaultMessage: "Check Out",
  },
  checkOutDescription: {
    id: "Check Out Now",
    defaultMessage: "Check Out Now",
  },
  editSelectionDescription: {
    id: "Edit Benefits Selection",
    defaultMessage: "Edit Benefits Selection",
  },
  continueShoppingDescription: {
    id: "Continue Shopping Wellness",
    defaultMessage: "Continue Shopping Wellness",
  },
  guaranteedSumDescription: {
    id: "Guaranteed Sum Assured:",
    defaultMessage: "Guaranteed Sum Assured:",
  },
  underwritingSumDescription: {
    id: "Subject to Underwriting Sum Assured:",
    defaultMessage: "Subject to Underwriting Sum Assured:",
  },
  showLessDescription: {
    id: "Show less",
    defaultMessage: "Show less",
  },
  showMoreDetailsDescription: {
    id: "Show more details",
    defaultMessage: "Show more details",
  },
  lastEnrolledSumDescription: {
    id: "Last_Enrolled_Sum",
    defaultMessage: "Last enrolled sum assured: {currency}{price}",
  },
  lastEnrolledBenefitDescription: {
    id: "Last_Enrolled_Benefit",
    defaultMessage: "Last enrolled benefit plan: {description}",
  },
  selectionNotesDescription: {
    id: "The Price Tag shown is Annual Premium (Prorated, if applicable)",
    defaultMessage: "The Price Tag shown is Annual Premium (Prorated, if applicable)",
  },
  selectDefaultDescription: {
    id: "SelectDefault_Last",
    defaultMessage: "Select Default /<br/>Last Accepted Cover",
  },
  continueDescription: {
    id: "Continue",
    defaultMessage: "Continue",
  },
  HDFRDescription: {
    id: "Health Declaration is Required.",
    defaultMessage: "Health Declaration is <strong>Required</strong>.",
  },
  notAvailableDescription: {
    id: "Not Available",
    defaultMessage: "Not Available",
  },
  defaultDescription: {
    id: "Default",
    defaultMessage: "Default",
  },
  recommendedDescription: {
    id: "Recommended",
    defaultMessage: "Recommended",
  },
  standardDescription: {
    id: "Standard",
    defaultMessage: "Standard",
  },
  noDependantDescription: {
    id: "No Dependant",
    defaultMessage: "No Dependant",
  },
  spouseDescription: {
    id: "+Spouse",
    defaultMessage: "+Spouse",
  },
  childrenDescription: {
    id: "+Children",
    defaultMessage: "+Children",
  },
  familyDescription: {
    id: "+Family",
    defaultMessage: "+Family",
  },
  dependantDescription: {
    id: "Dependant",
    defaultMessage: "Dependant",
  },
  NAValueDescription: {
    id: "NA Value",
    defaultMessage: "NA {name} {price}",
  },
  failedUpdateProfileDescription: {
    id: "Failed to update profile.",
    defaultMessage: "Failed to update profile.",
  },
  viewAsHtmlDescription: {
    id: "View as HTML",
    defaultMessage: "View as HTML",
  },
  watchTutorialText: {
    id: "Tutorial: See how it works",
    defaultMessage: "Tutorial: See how it works",
  },
  mydependantsDescription: {
    id: "My Dependants",
    defaultMessage: "My Dependants",
  },
  noteContentDescription: {
    id: "noteContentDescription",
    defaultMessage: "Please inform HR if you have any discrepancies/updates in your personal data.",
  },
  noteContentProfile: {
    id: "noteContentProfile",
    defaultMessage: "Please inform HR if you have any discrepancies/updates in your personal data.",
  },
  myProfileDescription: {
    id: "My Profile",
    defaultMessage: "My Profile",
  },
  mylifestageDescription: {
    id: "My Life Stage",
    defaultMessage: "My Life Stage",
  },
  advancedScreeningResultNotYetAvailableDescription: {
    id: "Your Screening results are not yet available.",
    defaultMessage: "Your Screening results are not yet available.",
  },
  launchPadLinkDescription: {
    id: "Go to Launchpad",
    defaultMessage: "Go to Launchpad",
  },
  lastUpdateTextDescription: {
    id: "LastUpdateText",
    defaultMessage: "Last update {when} by {who}",
    values: {
      when: <em>when</em>,
      who: <em>who</em>,
    },
  },
  printTextDescription: {
    id: "Print",
    defaultMessage: "Print",
  },
  colourGuideHeaderDescription: {
    id: "Colour Guide",
    defaultMessage: "Colour Guide",
  },
  unhealthyHighRiskDescription: {
    id: "Unhealthy / High Risk",
    defaultMessage: "Unhealthy / High Risk",
  },
  cautionModerateRiskDescription: {
    id: "Caution / Moderate Risk",
    defaultMessage: "Caution / Moderate Risk",
  },
  healthLowRiskDescription: {
    id: "Healthy / Low Risk",
    defaultMessage: "Healthy / Low Risk",
  },
  riskFactorsDescription: {
    id: "Your Lifestyle Risk Factors",
    defaultMessage: "Your Lifestyle Risk Factors",
  },
  smokingDescription: {
    id: "Smoking",
    defaultMessage: "Smoking",
  },
  activityDescription: {
    id: "Activity",
    defaultMessage: "Activity",
  },
  screeningDescription: {
    id: "Screening",
    defaultMessage: "Screening",
  },
  nutritionDescription: {
    id: "Nutrition",
    defaultMessage: "Nutrition",
  },
  stressDescription: {
    id: "Stress",
    defaultMessage: "Stress",
  },
  bodyFatDescription: {
    id: "Body Fat",
    defaultMessage: "Body Fat",
  },
  painDescription: {
    id: "Pain",
    defaultMessage: "Pain",
  },
  alcoholDescription: {
    id: "Alcohol",
    defaultMessage: "Alcohol",
  },
  sleepDescription: {
    id: "Sleep",
    defaultMessage: "Sleep",
  },
  mentalHealthDescription: {
    id: "Mental Health",
    defaultMessage: "Mental Health",
  },
  speaktoDoctorDescription: {
    id: "Speak to your doctor",
    defaultMessage: "Speak to your doctor",
  },
  showReportDescription: {
    id:
      "Show this report and ask about the lifestyle changes, treatment and screening options that are best for you",
    defaultMessage:
      "Show this report and ask about the lifestyle changes, treatment and screening options that are best for you",
  },
  purchasedProductsDescription: {
    id: "Purchased Products",
    defaultMessage: "Purchased Products",
  },
  insuranceStatementDescription: {
    id:
      "Products listed below have been purchased on this site. Confirmation with policy number and documents will be sent directly to your email. Please #contact# with any questions.",
    defaultMessage:
      "Products listed below have been purchased on this site. Confirmation with policy number and documents will be sent directly to your email. Please #contact# with any questions.",
  },
  loggedInImpersonationTextDescription: {
    id: "You are currently logged in. Select OK to login as another user.",
    defaultMessage: "You are currently logged in. Select OK to login as another user.",
  },
  userImpersonationTextDescription: {
    id: "User impersonation in progress",
    defaultMessage: "User impersonation in progress",
  },
  loggedInTextDescription: {
    id: "Login",
    defaultMessage: "Login",
  },
  endedLoginDescription: {
    id: "endedLoginDescription",
    defaultMessage: "Ended login in another device."
  },
  sendVerificationEmailMessage1: {
    id: "login.verificationEmail.title",
    defaultMessage: "<p><strong>A verification email has been sent to your inbox ending with </strong></p>"
  },
  sendVerificationEmailMessage2: {
    id: "login.verificationEmail.description",
    defaultMessage: "<p><strong>Please check your email to provide a valid mobile phone number to set up 2-Factor Authentication.</strong></p>"
  },
  twoFaSetupTitle: {
    id: "login.twoFA",
    defaultMessage: "2-Factor Authentication",
  },
  twoFaSetupMessage1: {
    id: "login.oneTimeVerification",
    defaultMessage: "A one-time verification Code will be sent to your mobile phone number via ",
  },
  twoFaSetupMessage2: {
    id: "login.validPhoneNumber",
    defaultMessage: "Please provide a valid mobile phone number and click on Send Verification Code.",
  },
  loginCountryCode: {
    id: "login.countryCode",
    defaultMessage: "Country Code:",
  },
  loginMobilePhoneNumber: {
    id: "login.mobilePhoneNumber",
    defaultMessage: "Mobile Phone Number:",
  },
  emailTokenErrorMessage: {
    id: "emailTokenErrorMessage",
    defaultMessage: "Email verification link had expired, please relogin.",
  },
  backToLoginButton: {
    id: "Back to Login",
    defaultMessage: "Back to Login",
  },
  sendVerificationCodeBtn: {
    id: "login.sendVerificationCode",
    defaultMessage: "Send Verification Code",
  },
  twoFAPhoneProvideCode: {
    id: "login.twoFAPhoneProvideCode",
    defaultMessage: "Please provide a verification code received from mobile phone number ending in <strong>{value}</strong>, via <strong>{via}</strong>",
  },
  twoFAEmailProvideCode: {
    id: "login.twoFAEmailProvideCode",
    defaultMessage: "Please provide a verification code received from email address <strong>{value}</strong>, via <strong>{via}</strong>",
  },
  clickVerifyButton: {
    id: "login.clickVerifyButton",
    defaultMessage: "Then click on Verify Code button.",
  },
  verificationCode: {
    id: "login.verificationCode",
    defaultMessage: "Verification Code:",
  },
  verifyCodeBtn: {
    id: "login.verifyCode",
    defaultMessage: "Verify Code",
  },
  expiryCodeCountdown: {
    id: "login.twoFAExpiresCountdown",
    defaultMessage: "Code expires in <strong>{minsDisplay}:{secsDisplay}</strong> {time}",
  },
  minsDescription: {
    id: "login.minsDescription",
    defaultMessage: "min",
  },
  secDescription: {
    id: "login.secDescription",
    defaultMessage: "sec",
  },
  tryOtherTwoFaMode: {
    id: "login.tryOtherTwoFaMode",
    defaultMessage: "Didn't receive your verification code?",
  },
  loginOr: {
    id: "login.or",
    defaultMessage: "or",
  },
  loginSendAgainVia: {
    id: "login.sendAgainVia",
    defaultMessage: "Send again via",
  },
  twoFAResendCooldown: {
    id: "login.twoFAResendCooldown.web",
    defaultMessage: "You can request verification code again only after {value} seconds from the previous request.",
  },
  twoFAUpdatePhoneNumberBtn: {
    id: "login.updatePhoneNumber",
    defaultMessage: "Update 2FA Phone Number",
  },
  twoFACodeExpired: {
    id: "login.twoFACodeExpired",
    defaultMessage: "Code has expired, please request for a new verification code.",
  },
  twoFANewCodeSent: {
    id: "login.twoFANewCodeSent",
    defaultMessage: "A new code has been sent.",
  },
  forgotLoginTextDescription: {
    id: "Forgot your login info?",
    defaultMessage: "Forgot your login info?",
  },
  companyIdDescription: {
    id: "Company ID:",
    defaultMessage: "Company ID",
  },
  policyIdDescription: {
    id: "Policy ID:",
    defaultMessage: "Policy ID",
  },
  loginIdDescription: {
    id: "Login ID:",
    defaultMessage: "Login ID",
  },
  passwordDescription: {
    id: "Password",
    defaultMessage: "Password",
  },
  passwordConfirmDescription: {
    id: "Confirm password",
    defaultMessage: "Confirm password",
  },
  membersLoginDescription: {
    id: "Members Login",
    defaultMessage: "Members Login",
  },
  businessNameDescription: {
    id: "Pacific Prime CXA. All Rights Reserved.",
    defaultMessage: "Pacific Prime CXA. All Rights Reserved.",
  },
  englishLanguage: {
    id: "englishLanguage",
    defaultMessage: "English",
  },
  contactDescription: {
    id: "Contact",
    defaultMessage: "Contact",
    values: {
      "Phone:": "Phone:",
      "Email:": "Email:",
      "Address:": "Address:",
    },
  },
  privacyDescription: {
    id: "Privacy",
    defaultMessage: "Privacy",
  },
  termsDescription: {
    id: "Terms",
    defaultMessage: "Terms",
  },
  passwordNotMatchDescription: {
    id: "Passwords do not match",
    defaultMessage: "Passwords do not match",
  },
  resetExpiredPasswordDescription: {
    id: "Reset Expired Password",
    defaultMessage: "Reset Expired Password",
  },
  changePasswordDescription: {
    id: "Change Password",
    defaultMessage: "Change Password",
  },
  updateDescription: {
    id: "Update",
    defaultMessage: "Update",
  },
  reviewDescription: {
    id: "Review",
    defaultMessage: "Review",
  },
  resetPasswordDescription: {
    id: "Reset Password",
    defaultMessage: "Reset Password",
  },
  submittingDescription: {
    id: "submitting",
    defaultMessage: "submitting",
  },
  cancelDescription: {
    id: "Cancel",
    defaultMessage: "Cancel",
  },
  requiredFieldSubtext: {
    id: "requiredFieldSubtext",
    defaultMessage: "Required",
  },
  updateNewPasswordDescription: {
    id: "Update New Password",
    defaultMessage: "Update New Password",
  },
  currentPasswordDescription: {
    id: "Current Password",
    defaultMessage: "Current Password",
  },
  newPasswordDescription: {
    id: "New Password",
    defaultMessage: "New Password",
  },
  retypeNewPasswordDescription: {
    id: "Retype New Password",
    defaultMessage: "Retype New Password",
  },
  nofileDescription: {
    id: "File not found (404). Not every search is fruitful.",
    defaultMessage: "File not found (404). Not every search is fruitful.",
  },
  resourceDoesNotExist: {
    id: "The requested document or resource does not exist:",
    defaultMessage: "The requested document or resource does not exist:",
  },
  passwordResetDescription: {
    id: "Password Reset",
    defaultMessage: "Password Reset",
  },
  enterIdDescription: {
    id: "Please enter your Login ID and Birth Date to Reset the Password.",
    defaultMessage: "Please enter your Login ID and Birth Date to Reset the Password.",
  },
  validateDescription: {
    id:
      "The system will validate and send you an email with instructions to complete the Password Reset.",
    defaultMessage:
      "The system will validate and send you an email with instructions to complete the Password Reset.",
  },
  brithDateDescription: {
    id: "general.birthDate",
    defaultMessage: "Birth Date",
  },
  dayDescription: {
    id: "general.day",
    defaultMessage: "Day",
  },
  monthDescription: {
    id: "general.month",
    defaultMessage: "Month",
  },
  yearDescription: {
    id: "general.year",
    defaultMessage: "Year",
  },
  birthMonthDescription: {
    id: "Birth Month",
    defaultMessage: "Birth Month",
  },
  birthYearDescription: {
    id: "Birth Year",
    defaultMessage: "Birth Year",
  },
  hasAcceptedTerms: {
    id: "I agree to terms",
    defaultMessage: "I consent to the {terms}",
  },
  termsAndConditions: {
    id: "Terms and Conditions",
    defaultMessage: "Terms and Conditions",
  },
  registerTitleDescription: {
    id: "Members Registration",
    defaultMessage: "Members Registration",
  },
  registerDescription: {
    id: "Please register for your activation link.",
    defaultMessage: "Please register for your activation link.",
  },
  editDetailsDescription: {
    id: "Edit Details",
    defaultMessage: "Edit Details",
  },
  confirmRegistrationText1Description: {
    id:
      "Thank you! An email has been sent to {email} with a link to complete your registration.  Please do so soon as the link will expire in approximately 1 hour.",
    defaultMessage:
      "Thank you! An email has been sent to {email} with a link to complete your registration.  Please do so soon as the link will expire in approximately 1 hour.",
  },
  confirmRegistrationText2Description: {
    id:
      "If you don’t receive the email, please check your spam or junk folder and the accuracy of the address.  You can resend the email from this form.",
    defaultMessage:
      "If you don’t receive the email, please check your spam or junk folder and the accuracy of the address.  You can resend the email from this form.",
  },
  passwordChangedNotificationDescription: {
    id: "Password changed successfully. You may now log in using your new password.",
    defaultMessage: "Password changed successfully. You may now log in using your new password.",
  },
  submittingStateDescription: {
    id: "submitting",
    defaultMessage: "submitting",
  },
  exceededPointsDescription: {
    id: "Exceeded_Points",
    defaultMessage:
      "You have exceeded your available points and {amount} will be deducted from your payroll. Please amend your selection if you do not wish to incur salary deduction.",
  },
  exceededPointsLimitDescription: {
    id: "Exceeded_Points_Limit",
    defaultMessage:
      "You have exceeded your available points and the limit allowed for deduction from your payroll.\nPlease amend your selection.",
  },
  walletDescription: {
    id: "Wallet",
    defaultMessage: "Wallet",
  },
  wellnessWalletNowHaveDescription: {
    id: "You now have",
    defaultMessage: "You now have",
  },
  wellnessWalletHaveSelectedDescription: {
    id: "Total Selected",
    defaultMessage: "Total Selected",
  },
  wellnessWalletExpandDescription: {
    id: "Expand",
    defaultMessage: "Expand",
  },
  wellnessWalletCollapseDescription: {
    id: "Collapse",
    defaultMessage: "Collapse",
  },
  viewStatmentDescription: {
    id: "View Statement",
    defaultMessage: "View Statement",
  },
  usageDescription: {
    id: "Usage",
    defaultMessage: "Usage",
  },
  subtotalDescription: {
    id: "Subtotal",
    defaultMessage: "Subtotal",
  },
  usedUpEntitlementDescription: {
    id: "and have used up your entitlement",
    defaultMessage: "and have used up your entitlement",
  },
  remainingBalanceDescription: {
    id: "Balance",
    defaultMessage: "Balance",
  },
  checkoutDescription: {
    id: "Checkout",
    defaultMessage: "Checkout",
  },
  gstDescription: {
    id: "All prices include GST",
    defaultMessage: "All prices include GST",
  },
  removeDescription: {
    id: "Remove",
    defaultMessage: "Remove",
  },
  phoneDescription: {
    id: "Phone",
    defaultMessage: "Phone:",
  },
  emailDescription: {
    id: "Email",
    defaultMessage: "Email:",
  },
  operatingHoursDescription: {
    id: "Operating Hours",
    defaultMessage: "Operating Hours",
  },
  providerOffersDescription: {
    id: "Provider Offers",
    defaultMessage: "Offers",
  },
  relatedOffersDescription: {
    id: "Related Offers",
    defaultMessage: "Related Offers",
  },
  seeAllRelatedOffersDescription: {
    id: "See all Related Offers",
    defaultMessage: "See all Related Offers",
  },
  purchaseDetailDescription: {
    id: "Purchase Details",
    defaultMessage: "Purchase Details",
  },
  staffDescription: {
    id: "Staff",
    defaultMessage: "Staff",
  },
  providerDescription: {
    id: "Provider",
    defaultMessage: "Provider",
  },
  locationsDescription: {
    id: "Locations",
    defaultMessage: "Locations",
  },
  whatsIncludedDescription: {
    id: "What's Included",
    defaultMessage: "What's Included",
  },
  TACDescription: {
    id: "T&C",
    defaultMessage: "T&C",
  },
  evoucherValidityDescription: {
    id: "eVoucher Validity",
    defaultMessage: "eVoucher Validity",
  },
  redeemNotiDescription: {
    id: "If you checked out today, you must redeem the eVoucher by",
    defaultMessage: "If you checked out today, you must redeem the eVoucher by",
  },
  notaxableBenefitDescription: {
    id: "Non-Taxable Benefit",
    defaultMessage: "Non-Taxable Benefit",
  },
  offerTaxDescription: {
    id: "Offers_Exempted_Tax",
    defaultMessage: "This offer is {isTaxableBenefitText} exempted from income tax.",
  },
  websiteDescription: {
    id: "Website",
    defaultMessage: "Website:",
  },
  howtoRedeemDescription: {
    id: "How to Redeem",
    defaultMessage: "How to Redeem",
  },
  CXATACDescription: {
    id: "CXA Terms and Conditions",
    defaultMessage: "CXA Terms and Conditions",
  },
  productTACDescription: {
    id: "Product Terms and Conditions",
    defaultMessage: "Product Terms and Conditions",
  },
  notDescription: {
    id: "not",
    defaultMessage: "not",
  },
  filterDescription: {
    id: "Filter",
    defaultMessage: "Filter",
  },
  filterByCategoryDescription: {
    id: "Filter by Category",
    defaultMessage: "Filter by Category",
  },
  filterByLocationDescription: {
    id: "Filter by Location",
    defaultMessage: "Filter by Location",
  },
  filterByPriceDescription: {
    id: "Filter by Price",
    defaultMessage: "Filter by Price",
  },
  filterByProviderDescription: {
    id: "Filter by Provider",
    defaultMessage: "Filter by Provider",
  },
  viewPagesDescription: {
    id: "View_per_page",
    defaultMessage: "View {pageSize} per page",
  },
  whichOffersDescription: {
    id: "Not sure which offers you need",
    defaultMessage: "Not sure which offers you need?",
  },
  reviewHRDescription: {
    id: "Review your health risks",
    defaultMessage: "Review your health risks",
  },
  lifestyleAgeingDescDefaultDescription: {
    id: "Are your lifestyle habits adding years to your appearance?",
    defaultMessage: "Are your lifestyle habits adding years to your appearance?",
  },
  lifestyleAgeingDescCompletedDescription: {
    id:
      "Your face ageing results are ready. Click 'View' to see if your lifestyle habits are adding years to your appearance.",
    defaultMessage:
      "Your face ageing results are ready. Click 'View' to see if your lifestyle habits are adding years to your appearance.",
  },
  lifestyleAgeingDescPSubmittedDescription: {
    id: "Your results should be available within 2 minutes.",
    defaultMessage: "Your results should be available within 2 minutes.",
  },
  lifestyleAgeingBtnDefaultDescription: {
    id: "Get Started",
    defaultMessage: "Get Started",
  },
  viewTextDescription: {
    id: "View",
    defaultMessage: "View",
  },
  lifestyleAgeingStatusStartDescription: {
    id: "start",
    defaultMessage: "start",
  },
  availableTextDescription: {
    id: "available",
    defaultMessage: "available",
  },
  lifestyleAgeingStatusProcessingDescription: {
    id: "processing",
    defaultMessage: "processing",
  },
  screeningDescNotDescription: {
    id: "Your health screening results are not yet available.",
    defaultMessage: "Your health screening results are not yet available.",
  },
  basicScreeningDescYesDescription: {
    id: "Your screening results are ready. Click 'View' to explore your numbers.",
    defaultMessage: "Your screening results are ready. Click 'View' to explore your numbers.",
  },
  startHereTextDescription: {
    id: "START HERE",
    defaultMessage: "START HERE",
  },
  unavailableTextDescription: {
    id: "unavailable",
    defaultMessage: "unavailable",
  },
  advancedScreeningDescYesDescription: {
    id:
      "Your advanced screening results are ready. Click View to explore your numbers with options to discuss them with a doctor.",
    defaultMessage:
      "Your advanced screening results are ready. Click View to explore your numbers with options to discuss them with a doctor.",
  },
  readBenefitTextDescription: {
    id:
      "Read the latest Benefits and Wellness articles from our panel of Contributors and Providers here.",
    defaultMessage:
      "Read the latest Benefits and Wellness articles from our panel of Contributors and Providers here.",
  },
  startLearningTextDescription: {
    id: "Start Learning",
    defaultMessage: "Start Learning",
  },
  upcomingDescription: {
    id: "Upcoming",
    defaultMessage: "Upcoming",
  },
  signUpDescription: {
    id: "Sign Up",
    defaultMessage: "Sign Up",
  },
  signUpsDescription: {
    id: "Sign Ups",
    defaultMessage: "Sign Ups",
  },
  completedDescription: {
    id: "Completed",
    defaultMessage: "Completed",
  },
  viewDetailsDescription: {
    id: "View Details",
    defaultMessage: "View Details",
  },
  cancelSignUpDescription: {
    id: "Cancel Sign Up",
    defaultMessage: "Cancel Sign Up",
  },
  downloadDescription: {
    id: "Download",
    defaultMessage: "Download",
  },
  scanQRCodeDescription: {
    id: "Scan QR Code",
    defaultMessage: "Scan QR Code",
  },
  pacificPrimePortalDescription: {
    id: "Pacific Prime CXA Portal",
    defaultMessage: "Pacific Prime CXA Portal",
  },
  welcomeToDescription: {
    id: "Welcome to",
    defaultMessage: "Welcome to",
  },
  infoTextDescription: {
    id: "Info",
    defaultMessage: "Info",
  },
  venueDescription: {
    id: "Venue",
    defaultMessage: "Venue",
  },
  locationDescription: {
    id: "Location",
    defaultMessage: "Location",
  },
  timeDescription: {
    id: "Time",
    defaultMessage: "Time",
  },
  whenDescription: {
    id: "When",
    defaultMessage: "When",
  },
  durationDescription: {
    id: "Duration",
    defaultMessage: "Duration",
  },
  placeLeftDescription: {
    id: "Places left",
    defaultMessage: "Places left",
  },
  showResultsDescription: {
    id: "Showing all { value0 } results",
    defaultMessage: "Showing all { value0 } results",
  },
  moderateExerciseDescription: {
    id: "Moderate Exercise",
    defaultMessage: "Moderate Exercise",
  },
  moderateActivityDescription: {
    id: "Activities that make you breathe harder and feel warm",
    defaultMessage: "Activities that make you breathe harder and feel warm",
  },
  vigorousExerciseDescription: {
    id: "Vigorous Exercise",
    defaultMessage: "Vigorous Exercise",
  },
  vigorousActivityDescription: {
    id: "Intense activities that make you feel out of breath and sweat",
    defaultMessage: "Intense activities that make you feel out of breath and sweat",
  },
  valuePositiveDescription: {
    id: "Value should be positive",
    defaultMessage: "Value should be positive",
  },
  valueUnrealisticDescription: {
    id: "Value is unrealistic",
    defaultMessage: "Value is unrealistic",
  },
  valueMaxDescription: {
    id: "Max value is {value0}",
    defaultMessage: "Max value is {value0}",
  },
  previousTextDescription: {
    id: "Previous",
    defaultMessage: "Previous",
  },
  nextTextDescription: {
    id: "Next",
    defaultMessage: "Next",
  },
  faceAgingAppearDescription: {
    id: "Your aged photo will appear here in about 5 minutes",
    defaultMessage: "Your aged photo will appear here in about 5 minutes",
  },
  healthyLifestyleDescription: {
    id: "Healthy Lifestyle",
    defaultMessage: "Healthy Lifestyle",
  },
  currentLifestyleDescription: {
    id: "Current Lifestyle",
    defaultMessage: "Current Lifestyle",
  },
  moveToChangeDescription: {
    id: "Move the slider to change the age",
    defaultMessage: "Move the slider to change the age",
  },
  learnMoreWithButtonsDescription: {
    id: "Learn more about your lifestyle factors by interacting with these buttons",
    defaultMessage: "Learn more about your lifestyle factors by interacting with these buttons",
  },
  cropfaceDescription: {
    id: "Crop your face area",
    defaultMessage: "Crop your face area",
  },
  drawBoxDescription: {
    id:
      "Now, draw a box around the face so that as much background as possible is removed. Place your cursor at the top left of the face and drag downward across to create a box as in the example image on the left. You need to make sure that the top of the head, ears and neck are inside the box.",
    defaultMessage:
      "Now, draw a box around the face so that as much background as possible is removed. Place your cursor at the top left of the face and drag downward across to create a box as in the example image on the left. You need to make sure that the top of the head, ears and neck are inside the box.",
  },
  reUploadDescription: {
    id: "Re-Upload",
    defaultMessage: "Re-Upload",
  },
  ageYourselfDescription: {
    id: "Age Yourself",
    defaultMessage: "Age Yourself",
  },
  answerQDescription: {
    id: "Answer Some Questions",
    defaultMessage: "Answer Some Questions",
  },
  yourResultsDescription: {
    id: "Your Results",
    defaultMessage: "Your Results",
  },
  askPhotoDescription: {
    id:
      "In order to meet the future you, we need to send us your photo. You can take a photo from your webcam or upload it from a file.",
    defaultMessage:
      "In order to meet the future you, we need to send us your photo. You can take a photo from your webcam or upload it from a file.",
  },
  askPhotoDescriptionNoCam: {
    id:
      "In order to meet the future you, we need to send us your photo. You can upload it from a file.",
    defaultMessage:
      "In order to meet the future you, we need to send us your photo. You can upload it from a file.",
  },
  photoGuidelinesDescription: {
    id: "Photo Guidelines",
    defaultMessage: "Photo Guidelines",
  },
  plainBackgroundDescription: {
    id: "Use a plain background",
    defaultMessage: "Use a plain background",
  },
  removeHatAndGlassedDescription: {
    id: "Remove hat and glasses",
    defaultMessage: "Remove hat and glasses",
  },
  useBrightDescription: {
    id: "Use bright lighting",
    defaultMessage: "Use bright lighting",
  },
  keepStraightDescription: {
    id: "Try to keep a straight face",
    defaultMessage: "Try to keep a straight face",
  },
  permissionDescription: {
    id:
      "To take a photo with your webcam, you must allow the app to access your camera when prompted.",
    defaultMessage:
      "To take a photo with your webcam, you must allow the app to access your camera when prompted.",
  },
  photoUploadDescription: {
    id: "Photo Upload",
    defaultMessage: "Photo Upload",
  },
  useExistingDescription: {
    id: "Do you want to use your existing HRA response in aging this photo?",
    defaultMessage: "Do you want to use your existing HRA response in aging this photo?",
  },
  toProcessDescription: {
    id: 'Click "Yes" to continue or "No" to proceed to the HRA questions.',
    defaultMessage: 'Click "Yes" to continue or "No" to proceed to the HRA questions.',
  },
  yesTextDescription: {
    id: "Yes",
    defaultMessage: "Yes",
  },
  noTextDescription: {
    id: "No",
    defaultMessage: "No",
  },
  takePhotoDescription: {
    id: "Take Photo",
    defaultMessage: "Take Photo",
  },
  skipTextDescription: {
    id: "Skip",
    defaultMessage: "Skip",
  },
  confirmTextDescription: {
    id: "Confirm",
    defaultMessage: "Confirm",
  },
  retakeTextDescription: {
    id: "Retake",
    defaultMessage: "Retake",
  },
  uploadPhotoTextDescription: {
    id: "Upload Photo",
    defaultMessage: "Upload Photo",
  },
  detailsTextDescription: {
    id: "Details",
    defaultMessage: "Details",
  },
  foodConsumeDescription: {
    id: "How many servings of these foods and drinks do you consume?",
    defaultMessage: "How many servings of these foods and drinks do you consume?",
  },
  subsectionTagTextDescription: {
    id: "Estimate how much time you spend doing these activities on a typical day",
    defaultMessage: "Estimate how much time you spend doing these activities on a typical day",
  },
  painDullAcheNumbnessDescription: {
    id: "Pain, dull ache, numbness",
    defaultMessage: "Pain, dull ache, numbness",
  },
  sensationDescription: {
    id: "Sensation of cold",
    defaultMessage: "Sensation of cold",
  },
  tinglingDescription: {
    id: "Tingling (pins and needles) or burning sensation",
    defaultMessage: "Tingling (pins and needles) or burning sensation",
  },
  tirednessDescription: {
    id: "Tiredness or soreness",
    defaultMessage: "Tiredness or soreness",
  },
  swellingDesctiption: {
    id: "Swelling or redness",
    defaultMessage: "Swelling or redness",
  },
  muscleDescription: {
    id: "Muscle spasm",
    defaultMessage: "Muscle spasm",
  },
  lossDescription: {
    id: "Loss of strength or movement",
    defaultMessage: "Loss of strength or movement",
  },
  frontDescription: {
    id: "Front",
    defaultMessage: "Front",
  },
  backDescription: {
    id: "Back",
    defaultMessage: "Back",
  },
  hoursDescription: {
    id: "hour/s",
    defaultMessage: "hour/s",
  },
  minutesDescription: {
    id: "minute/s",
    defaultMessage: "minute/s",
  },
  whatDrinkDescription: {
    id: "What is a drink",
    defaultMessage: "What is a drink",
  },
  mixDrinkUnitDescription: {
    id: "One mixed drink with 1.5 fl oz (44mL) of 40% alcohol by volume",
    defaultMessage: "One mixed drink with 1.5 fl oz (44mL) of 40% alcohol by volume",
  },
  winDrinkUnitDescription: {
    id: "5 fl oz (148mL) of wine",
    defaultMessage: "5 fl oz (148mL) of wine",
  },
  beerwinDrinkUnitDescription: {
    id: "12 fl oz (355mL) of beer or wine cooler",
    defaultMessage: "12 fl oz (355mL) of beer or wine cooler",
  },
  highfatDescription: {
    id: "High fat foods",
    defaultMessage: "High fat foods",
  },
  lowFatDescription: {
    id: "Low fat foods",
    defaultMessage: "Low fat foods",
  },
  breadgrainDescription: {
    id: "Types of breads and grains",
    defaultMessage: "Types of breads and grains",
  },
  wholeGrainDescription: {
    id: "Whole Grains e.g. brown rice and brown bread",
    defaultMessage: "Whole Grains e.g. brown rice and brown bread",
  },
  refinedGrainDescription: {
    id: "Refined Grains e.g. pasta, white rice, white bread, noodles and crackers",
    defaultMessage: "Refined Grains e.g. pasta, white rice, white bread, noodles and crackers",
  },
  //newly added of 05/04/2017
  selectYourEthnicityDescription: {
    id: "Select your ethnicity",
    defaultMessage: "Select your ethnicity",
  },
  shoppingCartEmptyDescription: {
    id: "Your Shopping Cart is empty.",
    defaultMessage: "Your Shopping Cart is empty.",
    isMissing: true,
  },
  fewerTextDescription: {
    id: "Fewer",
    defaultMessage: "Fewer",
    isMissing: true,
  },
  moreTextDescription: {
    id: "More",
    defaultMessage: "More",
    isMissing: true,
  },
  choosePhotoDescription: {
    id: "Please choose a photo to upload",
    defaultMessage: "Please choose a photo to upload",
    isMissing: true,
  },
  aboutDescription: {
    id: "About",
    defaultMessage: "About",
    isMissing: true,
  },
  suggestionsDescription: {
    id: "Suggestions",
    defaultMessage: "Suggestions",
    isMissing: true,
  },
  whatresultsMeanDescription: {
    id: "What do your results mean?",
    defaultMessage: "What do your results mean?",
    isMissing: true,
  },
  genderDescription: {
    id: "Gender",
    defaultMessage: "Gender",
    isMissing: true,
  },
  ageDescription: {
    id: "Age",
    defaultMessage: "Age",
    isMissing: true,
  },
  weightDescription: {
    id: "Weight",
    defaultMessage: "Weight",
    isMissing: true,
  },
  heightDescription: {
    id: "Height",
    defaultMessage: "Height",
    isMissing: true,
  },
  dateDescription: {
    id: "Date",
    defaultMessage: "Date",
    isMissing: true,
  },
  stronglyDisagreeDescription: {
    id: "Strongly Disagree",
    defaultMessage: "Strongly Disagree",
    isMissing: true,
  },
  disagreeDescription: {
    id: "Neither Agree Nor Disagree",
    defaultMessage: "Neither Agree Nor Disagree",
    isMissing: true,
  },
  stronglyAgreeDescription: {
    id: "Strongly Agree",
    defaultMessage: "Strongly Agree",
    isMissing: true,
  },
  titleRepresentServingDescription: {
    id: "Each title represents a serving",
    defaultMessage: "Each title represents a serving",
    isMissing: true,
  },
  dietInfoDescriptionBroccoli: {
    id: "Broccoli: A generous fistful (tennis ball size) of florets or about 16 small florets",
    defaultMessage:
      "Broccoli: A generous fistful (tennis ball size) of florets or about 16 small florets",
    isMissing: true,
  },
  dietInfoDescriptionCarrots: {
    id: "2 medium carrots",
    defaultMessage: "2 medium carrots",
    isMissing: true,
  },
  dietInfoDescriptionCapsicum: {
    id: "1 cup chopped or 1 large pepper",
    defaultMessage: "1 cup chopped or 1 large pepper",
    isMissing: true,
  },
  dietInfoDescriptionVegetables: {
    id: "1/2 cup cooked vegetable or cooked legumes",
    defaultMessage: "1/2 cup cooked vegetable or cooked legumes",
    isMissing: true,
  },
  dietInfoDescriptionSalad: {
    id: "1 cup salad vegetables",
    defaultMessage: "1 cup salad vegetables",
    isMissing: true,
  },
  dietInfoDescriptionSugar: {
    id: "1 teaspoon of sugar",
    defaultMessage: "1 teaspoon of sugar",
    isMissing: true,
  },
  dietInfoDescriptionCake: {
    id: "1 slice of cake",
    defaultMessage: "1 slice of cake",
    isMissing: true,
  },
  dietInfoDescriptionApple: {
    id: "1 medium apple",
    defaultMessage: "1 medium apple",
    isMissing: true,
  },
  dietInfoDescriptionBanana: {
    id: "1 large banana (8 or 9 inches long)",
    defaultMessage: "1 large banana (8 or 9 inches long)",
    isMissing: true,
  },
  dietInfoDescriptionOrange: {
    id: "1 large orange (a little bigger than a baseball)",
    defaultMessage: "1 large orange (a little bigger than a baseball)",
    isMissing: true,
  },
  dietInfoDescriptionPear: {
    id: "1 medium pear",
    defaultMessage: "1 medium pear",
    isMissing: true,
  },
  dietInfoDescriptionFruit: {
    id: "1 cup chopped or canned fruit",
    defaultMessage: "1 cup chopped or canned fruit",
    isMissing: true,
  },
  dietInfoDescriptionSoda: {
    id: "1 can of soda",
    defaultMessage: "1 can of soda",
    isMissing: true,
  },
  dietInfoDescriptionChocolate: {
    id: "1 chocolate bar",
    defaultMessage: "1 chocolate bar",
    isMissing: true,
  },
  eVoucherExpiryValueDescription: {
    id: "eVoucher Expiry {value0}",
    defaultMessage: "eVoucher Expiry {value0}",
  },
  proceedToPaymentDescription: {
    id: "Proceed to Payment",
    defaultMessage: "Proceed to Payment",
  },
  payDescription: {
    id: "Pay",
    defaultMessage: "Pay",
  },
  employerPaysDescription: {
    id: "Employer Pays",
    defaultMessage: "Employer Pays",
  },
  totalPayableDescription: {
    id: "Total Payable",
    defaultMessage: "Total Payable",
  },
  sortByDescription: {
    id: "Sort by",
    defaultMessage: "Sort by",
  },
  suggestedContentDescription: {
    id: "Suggested Content",
    defaultMessage: "Suggested Content",
  },
  employeePaysDescription: {
    id: "Employee Pays",
    defaultMessage: "Employee Pays",
  },
  markerxyNotMatchDescription: {
    id: "Marker X and Y lengths don't match",
    defaultMessage: "Marker X and Y lengths don't match",
  },
  knowYourHealthDescription: {
    id: "KNOW YOUR HEALTH",
    defaultMessage: "KNOW YOUR HEALTH",
  },
  healthierHabitsDescription: {
    id: "Healthier habits",
    defaultMessage: "Healthier habits",
  },
  currentHabitsDescription: {
    id: "Current habits",
    defaultMessage: "Current habits",
  },
  disclaimerDescription: {
    id:
      "This program and its contents are designed to be educational and informative and must not be treated as a substitute for medical advice from a personal physician or other healthcare professional",
    defaultMessage:
      "This program and its contents are designed to be educational and informative and must not be treated as a substitute for medical advice from a personal physician or other healthcare professional",
  },
  disclaimerTextDescription: {
    id: "Disclaimer",
    defaultMessage: "Disclaimer",
  },
  daysTextDescription: {
    id: "days",
    defaultMessage: "days",
  },
  hoursTextDescription: {
    id: "hours",
    defaultMessage: "hours",
  },
  minutesTextDescription: {
    id: "minutes",
    defaultMessage: "minutes",
  },
  secondsTextDescription: {
    id: "seconds",
    defaultMessage: "seconds",
  },
  privacyLink: {
    id: "#Client_Privacy_Policy#",
    defaultMessage:
      "https://documents.cxaone.com/Clients/Common/Documents/Pacific_Prime_CXA_Data_Privacy.pdf",
  },
  privacyLinktoWebsite: {
    id: "#Client_Privacy_Policy_Website#",
    defaultMessage: "https://www.cxagroup.com/data-privacy",
  },
  termsLink: {
    id: "#Client_Terms_And_Condition#",
    defaultMessage:
      "https://documents.cxaone.com/Clients/Common/Documents/pacific_prime_cxa_terms_and_conditions.pdf",
  },
  accountsOverviewDescription: {
    id: "Accounts Overview",
    defaultMessage: "Accounts Overview",
  },
  updateMyPasswordDescription: {
    id: "Update My Password",
    defaultMessage: "Update My Password",
  },
  removeItemDescription: {
    id: "Remove Item",
    defaultMessage: "Remove Item",
  },
  removeItemMessageDescription: {
    id: "Remove Item Message",
    defaultMessage: "Remove {name} for {entity} from your cart?",
  },
  continueShoppingInsuranceDescription: {
    id: "Continue Shopping",
    defaultMessage: "Continue Shopping",
  },
  currentSpending: {
    id: "Current Spending",
    defaultMessage: "Current Spending",
  },
  cart: {
    id: "Cart",
    defaultMessage: "Cart",
  },
  enterDetailsFor: {
    id: "Enter details for",
    defaultMessage: "Enter details for",
  },
  accountLockedDescription: {
    id: "ACCOUNT_LOCKED",
    defaultMessage:
      "Your account has been locked, unlock your account by resetting your password [here](/forgotPassword?loginpage=resethere).",
  },
  credentialWrongDescription: {
    id: "CREDENTIAL_WRONG",
    defaultMessage: "You have provided the wrong credentials. Please check your entries again.",
  },
  invalidAccountDescription: {
    id: "INVALID_ACCOUNT",
    defaultMessage: "Invalid Account",
  },
  insured: {
    id: "Insured",
    defaultMessage: "Insured",
  },
  dontGoAnywhere: {
    id: "Don't go anywhere...",
    defaultMessage: "Don't go anywhere...",
  },
  transactionProcessed: {
    id: "Your transaction is being processed and will finish up soon.",
    defaultMessage: "Your transaction is being processed and will finish up soon.",
  },
  thankYou: {
    id: "Thank you.",
    defaultMessage: "Thank you.",
  },
  copyrightText: {
    id: "All Rights Reserved.",
    defaultMessage: "All Rights Reserved.",
  },
  errorTitle: {
    id: "Error",
    defaultMessage: "Error",
  },
  confirmPasswordErrorDescription: {
    id: "Confirm password is not same",
    defaultMessage: "Confirm password is not same",
  },
  acceptTermsErrorDescription: {
    id: "Terms and Conditions have to be accepted",
    defaultMessage: "Terms and Conditions have to be accepted",
  },
  accountLabel: {
    id: "Me",
    defaultMessage: "Me",
  },
  accountInfoDescription: {
    id: "Account Info",
    defaultMessage: "Account Info",
  },
  needHelpFooter: {
    values: {
      "For queries, please contact us at:": "For queries, please contact us at:",
      "Helpline:": "Helpline:",
      "Our office hour is from 8am to 6pm Mondays to Fridays, excluding Saturdays, Sundays and Singapore Public Holidays":
        "Our office hour is from 8am to 6pm Mondays to Fridays, excluding Saturdays, Sundays and Singapore Public Holidays",
      "Email:": "Email:",
    },
  },
  needHelpHeader: {
    values: {
      "For queries, please contact us at:": "For queries, please contact us at:",
    },
  },
  needHelpNotes: {
    id: "Need Help Notes",
    defaultMessage:
      'Not sure about the type of claim to select? Click "Need Help" to answer a few questions for the system to suggest the applicable type of claims.',
  },
  needHelpQuestionSubmit: {
    id: "Need Help Question Submit",
    defaultMessage: "What type of claim do you want to submit?",
  },
  needHelpSupport: {
    id: "Need Help Purpose",
    defaultMessage: "Type the purpose of the claim, e.g., Outpatient, Dental, Maternity",
  },
  needHelpOptionalQuestions: {
    id: "Need Help Optional Questions",
    defaultMessage: "Answer the optional questions below to refine the applicable claim types",
  },
  needHelpDisabled: {
    id: "Need Help Disabled",
    defaultMessage:
      "We can’t find a matching claim type for the keyword entered. Please search using different keywords or click on “Need Settings” to go back and choose based on type of claim icons.",
  },
  needHelp: {
    id: "Need Help",
    defaultMessage: "Need Help",
  },
  apply: {
    id: "Apply",
    defaultMessage: "Apply",
  },
  ofSeparator: {
    id: "of",
    defaultMessage: "of",
  },
  policyDescription: {
    values: {
      "The password must meet the following password policy:":
        "The password must meet the following password policy:",
      "Minimum password length of 8 characters": "Minimum password length of 8 characters",
      "Minimum of 1 uppercase character": "Minimum of 1 uppercase character",
      "- Minimum of 1 lowercase character": "- Minimum of 1 lowercase character",
      "- Minimum of 1 numeric digit": "- Minimum of 1 numeric digit",
    },
  },
  passwordPolicy: {
    id: "config.passwordPolicy",
    defaultMessage: "The password must meet the following password policy:\r\n- Minimum password length of 8 characters\r\n- Minimum of 1 uppercase character\r\n- Minimum of 1 lowercase character\r\n- Minimum of 1 numeric digit\r\n- Minimum of 1 special character"
  },
  benefitConfirmMsg: {
    id: "config.benefitConfirmMsg",
    defaultMessage: 'Please go to the Selection page and click on "Review &amp; Confirm" to finalise your selections. Otherwise, core benefits will be applied.'
  },
  hdfCheckoutWebpageDisclaimer: {
    id: "config.hdfCheckoutWebpageDisclaimer",
    defaultMessage: 'The insurer needs to know about your health, lifestyle, occupation and family history before approving your selected benefit upgrades. Your can continue to checkout your selections.  Any selection that requires Health declaration will be reset to last approved coverage, if Health declaration form is not submitted within the enrolment end date'
  },
  hdfCheckoutMobileResponsiveDisclaimer: {
    id: "config.hdfCheckoutMobileResponsiveDisclaimer",
    defaultMessage: 'The insurer needs to know about your health, lifestyle, occupation and family history before approving your selected benefit upgrades. You will receive an email with the link to submit Health declaration form upon clicking “Checkout” button.Your can continue to checkout your selections.  Any selection that requires Health declaration will be reset to last approved coverage, if Health declaration form is not submitted within the enrolment end date'
  },
  checkoutNote: {
    id: "config.checkoutNote",
    defaultMessage: '<b>Note:</b>&nbsp;You will not be allowed to make amendments to your selection/purchase after checking out. Should you choose to go on leave for a continuous duration of 12 months or longer, the insurer may not accept your <span class="wiseone-analysis-result wiseone-analysis-result-entity">insurance claims</span>.'
  },
  salaryDeductionNote: {
    id: "config.salaryDeductionNote",
    defaultMessage: 'You have exhausted your applicable points by [ExcessAmount]. Payroll deduction would incur if your carried forward points are not sufficient to offset this shortfall.'
  },
  noTotalRewards: {
    id: "noTotalRewards",
    defaultMessage: "No Total Rewards Information available for employee!"
  },
  freePriceDescription: {
    id: "Free",
    defaultMessage: "Free",
  },
  unAuthorizedAccess: {
    id: "You are not authorized to access this page.",
    defaultDescription: "You are not authorized to access this page.",
  },
  purchaseQuantityLimit: {
    id:
      "You've exceeded the maximum purhcase amount.  Each employee is only allowed to purchase 1 unit of this offer.",
    defaultMessage:
      "You've exceeded the maximum purhcase amount.  Each employee is only allowed to purchase 1 unit of this offer.",
  },
  consentMessage: {
    id:
      "General Terms & Conditions - Consent<br><br>By clicking on the I consent button, I agree (a) that CXA may collect, keep and use my personal data and contact me (as applicable) for providing to me CXA services; (b) to the terms relating to the CXA Portal, including the general terms of use of the portal and associated online services and mobile applications; and (c) to CXA's Privacy Policy (which may incorporate my insurer's privacy policy), and understand that apart from necessary business use (such as claims processing or underwriting), my personal data will not be shared with my employer in any way that personally identifies me. My agreements apply to all my dealings with CXA, including through mobile apps, Internet portals and other electronic systems or properties.<br><br>I acknowledge that I have read and accepted the General Terms & Conditions associated with the use of the CXA Portal and associated online services, including but not limited to mobile applications.",
    defineMessage:
      "General Terms & Conditions - Consent<br><br>By clicking on the I consent button, I agree (a) that CXA may collect, keep and use my personal data and contact me (as applicable) for providing to me CXA services; (b) to the terms relating to the CXA Portal, including the general terms of use of the portal and associated online services and mobile applications; and (c) to CXA's Privacy Policy (which may incorporate my insurer's privacy policy), and understand that apart from necessary business use (such as claims processing or underwriting), my personal data will not be shared with my employer in any way that personally identifies me. My agreements apply to all my dealings with CXA, including through mobile apps, Internet portals and other electronic systems or properties.<br><br>I acknowledge that I have read and accepted the General Terms & Conditions associated with the use of the CXA Portal and associated online services, including but not limited to mobile applications.",
  },
  usefulProductsForYou: {
    id: "Useful Products For You",
    defineMessage: "Useful Products For You",
  },
  findOutMore: {
    id: "Find Out More",
    defineMessage: "Find Out More",
  },
  readMore: {
    id: "dashboard.readMore",
    defaultMessage: "Read More",
  },
  hrAdministerMessage: {
    id:
      "Welcome {hrAdminFullname}. Administering Employee: [{employeeUsername}, {employeeFullname}]",
    defaultMessage:
      "Welcome {hrAdminFullname}. Administering Employee: [{employeeUsername}, {employeeFullname}]",
  },
  hrAdministerMessageAdminUser: {
    id: "Welcome {hrAdminFullname}.",
    defaultMessage: "Welcome {hrAdminFullname}.",
  },
  downloadReport: {
    id: "Download Report",
    defaultMessage: "Download Report",
  },
  sendEmail: {
    id: "Send Email",
    defaultMessage: "Send Email",
  },
  browseFilesDescription: {
    id: "Browse Files",
    defaultMessage: "Browse Files",
  },
  dropThemHereDescription: {
    id: "or drop them here",
    defaultMessage: "or drop them here",
  },
  unSaveBenefitMessage: {
    id: "If you leave this page now all your benefits selection won't be saved",
    defaultMessage: "If you leave this page now all your benefits selection won't be saved",
  },
  unSaveGenHDFMessage: {
    id: "benefit.genHdfUnSave",
    defaultMessage: "Please note that if you leave this page now, your progress won't be saved.\nWould you like to continue?",
  },
  GENHDF_SUBMIT_FAILURE_MESSAGE: {
    id: "GENHDF_SUBMIT_FAILURE_MESSAGE",
    defaultMessage: "The form failed to submit. Please ensure you have completed all required fields as marked.",
  },
  menuTextDescription: {
    id: "Menu",
    defaultMessage: "Menu",
  },
  searchEmployee: {
    id: "Search on Employee ID, Name, NRIC/Passport No and Department.",
    defineMessage: "Search on Employee ID, Name, NRIC/Passport No and Department.",
  },
  activeEmployees: {
    id: "Active Employees",
    defineMessage: "Active Employees",
  },
  terminatedEmployees: {
    id: "Terminated Employees",
    defineMessage: "Terminated Employees",
  },
  invalidDateFormat: {
    id: "The date entered is either an invalid date, or not in the correct format.",
    defaultMessage: "The date entered is either an invalid date, or not in the correct format.",
  },
  hrImpersonateUserMessage: {
    id: "You are acting on behalf of",
    defaultMessage: "You are acting on behalf of {hrAdminFullname}",
  },
  hrEndImpersonateUserMessage: {
    id: "End Impersonation",
    defaultMessage: "End Impersonation",
  },
  daysLeftDescription: {
    id: "Left",
    defaultMessage: "Left",
  },
  activitySignUpDescription: {
    id: "Are you sure you want to sign up?",
    defaultMessage: "Are you sure you want to sign up to {activityName}?",
  },
  removeActivityDescription: {
    id: "Are you sure you want to cancel your sign up?",
    defaultMessage: "Are you sure you want to cancel your sign up for {activityName}?",
  },
  totalActivityExceed24hrs: {
    id: "The total amount of time spent on these activities exceeded 24 hours.",
    defaultMessage: "The total amount of time spent on these activities exceeded 24 hours.",
  },
  healthAssessmentMustComplete: {
    id: "Please complete the Health Assessment questions to get your results.",
    defaultMessage: "Please complete the Health Assessment questions to get your results.",
  },
  activityRequire1Hour: {
    id: "Please check that each activity is at least 1 hour.",
    defaultMessage: "Please check that each activity is at least 1 hour.",
  },
  loginMultiLoginLabel: {
    id: "Please select your preferred login",
    defaultMessage: "Please select your preferred login",
  },
  clientProviderLoginButtonText: {
    id: "{provider} Login",
    defaultMessage: "{provider} Login",
  },
  cxaOneDefaultLoginButtonText: {
    id: "CXA Login",
    defaultMessage: "CXA Login",
  },
  poweredByDescription: {
    id: "Powered by",
    defaultMessage: "Powered by",
  },
  tayloredOfferDescription: {
    id: "Want Tailored Health Offers?",
    defaultMessage: "Want Tailored Health Offers?",
  },
  howHealthyDescription: {
    id: "Tell us how healthy you are.",
    defaultMessage: "Tell us how healthy you are.",
  },
  withShopTakeQuestionnaireDescription: {
    id:
      "Our shop is packed with thousand of offers. Take our questionnaire to see what best fits your needs.",
    defaultMessage:
      "Our shop is packed with thousand of offers. Take our questionnaire to see what best fits your needs.",
  },
  wantToSeeFutureDescription: {
    id: "Want to see the future?",
    defaultMessage: "Want to see the future?",
  },
  withoutShopTakeQuestionnaireDescription: {
    id:
      "Your health is important for your future. Take our questionnaire to see the future you with our face aging app.",
    defaultMessage:
      "Your health is important for your future. Take our questionnaire to see the future you with our face aging app.",
  },
  startNowDescription: {
    id: "Start Now",
    defaultMessage: "Start Now",
  },
  downloadFileDescription: {
    id: "Download File",
    defaultMessage: "Download File",
  },
  webcamFailed: {
    id: "Webcam_Failed",
    defaultMessage: "Oh no! The webcam failed to load: {message} {name}",
  },
  activities: {
    notSignedUp: {
      id: "activities.notSignedUp",
      defaultMessage: "You haven't signed up to any activities.",
    },
    noCompletedActivities: {
      id: "activities.noCompletedActivities",
      defaultMessage: "You haven't completed any activities.",
    },
  },
  screening: {
    healthScreeningTitle: {
      id: "screening.healthScreeningTitle",
      defaultMessage: "Health Screening",
    },
  },
  dashboard: {
    cxaShopOpen: {
      id: "dashboard.cxaShopOpen",
      defaultMessage: "PPCXAShop <br/> Now Open!",
    },
    visitCXAShop: {
      id: "dashboard.visitCXAShop",
      defaultMessage: "Visit PPCXAShop Now",
    },
    downloadApp: {
      enterMobileNumber: {
        id: "dashboard.downloadApp.enterMobileNumber",
        defaultMessage: "Enter Mobile Number",
      },
      smsFailed: {
        id: "dashboard.downloadApp.smsFailed",
        defaultMessage:
          "We could not send you an SMS. Please check your phone number and try again.",
      },
      smsSuccess: {
        id: "dashboard.downloadApp.smsSuccess",
        defaultMessage: "A text message with the CXA Mobile App Link has been sent.",
      },
    },
    enrolment: {
      enrolmentDurationDescription: {
        id: "dashboard.enrolment.enrolmentDurationDescription",
        defaultMessage: "Enrolment started on {startDate}; Enrolment ends on {endDate}",
      },
    },
  },
  filterBox_clearAllFilter: {
    id: "filterBox:learAllFilter : {",
    defaultMessage: "Clear All Filters",
  },
  filterBox_resultClearFilter: {
    id: "filterBox:resultClearFilter",
    defaultMessage: "Clear Filter(s)",
  },
  login: {
    loginSelectionHeaderTitle: {
      id: "login.loginSelectionHeaderTitle",
      defaultMessage: "Members Login",
    },
    loginHeaderTitle: {
      id: "login.loginHeaderTitle",
      defaultMessage: "Login with CXA Account",
    },
    userNameHint: {
      id: "login.userNameHint",
      defaultMessage: "Enter the email address",
    },
    passwordHint: {
      id: "login.passwordHint",
      defaultMessage: "Enter the password; Passwords are case sensitive",
    },
  },
  shop: {
    completeHealthReviewText: {
      id: "shop.completeHealthReviewText",
      defaultMessage: "Complete your {link} to see your personalised Health & Wellness products.",
    },
  },
  benefitsStatement_SelectPlanYear: {
    id: "benefitsStatement.selectPlanYear",
    defaultMessage: "[Select Plan Year]",
  },
  voucherResendNotification: {
    id: "voucherResendNotification",
    defaultMessage: "Your e-voucher will be sent to your mailbox shortly.",
  },
  delegation: {
    employees: {
      title: {
        id: "delegation.employees.title",
        defaultMessage: "Delegation",
      },
      backToButton: {
        id: "delegation.employees.backToButton",
        defaultMessage: "Go back to Delegation",
      },
      addButton: {
        id: "delegation.employees.addButton",
        defaultMessage: "Add Delegation",
      },
      editButton: {
        id: "delegation.employees.editButton",
        defaultMessage: "Edit",
      },
      revokeButton: {
        id: "delegation.employees.revokeButton",
        defaultMessage: "Revoke",
      },
      revokeOn: {
        id: "delegation.employees.revokeOn",
        defaultMessage: "Revoke On",
      },
    },
    search: {
      title: {
        id: "delegation.search.title",
        defaultMessage: "Search and Select an Employee",
      },
      notes: {
        id: "delegation.search.notes",
        defaultMessage:
          "You can type a portion (minimum 3 characters) of the employee name, click on Search, and select the employee.",
      },
      note: {
        id: "delegation.search.note",
        defaultMessage: "Note",
      },
    },
    addEdit: {
      title: {
        id: "delegation.addEdit.title",
        defaultMessage: "Add / Edit Delegation",
      },
      delegateTo: {
        id: "delegation.addEdit.delegateTo",
        defaultMessage: "Delegate To",
      },
      delegate: {
        id: "delegation.addEdit.delegate",
        defaultMessage: "Delegate",
      },
      fromDate: {
        id: "delegation.addEdit.fromDate",
        defaultMessage: "From",
      },
      endDate: {
        id: "delegation.addEdit.endDate",
        defaultMessage: "To",
      },
    },
    agreement: {
      message: {
        id: "delegation.agreement.message",
        defaultMessage:
          "I choose to delegate to a colleague, the colleague whom I delegate will be able to see my budget allocation",
      },
      agreeBtn: {
        id: "general.iAgree",
        defaultMessage: "I agree",
      },
      cancelBtn: {
        id: "general.cancel",
        defaultMessage: "Cancel",
      },
    },
    revoke: {
      message: {
        id: "delegation.revoke.message",
        defaultMessage: "You are about to revoke the Delegation: {employeeDelegation}. \n Proceed?",
      },
    },
  },
  passwordReset: {
    passwordResetMessage: {
      id: "passwordReset.passwordResetMessage",
      defaultMessage:
        "You may now set your new password. Your login account will be enabled with your new password.",
    },
  },
  inAppMessages: {
    messages: {
      id: "inAppMessages.messages",
      defaultMessage: "Messages",
    },
    newMessage: {
      id: "inAppMessages.newMessage",
      defaultMessage: "New Message",
    },
    messageSentDialogTitle: {
      id: "inAppMessages.messageSentDialogTitle",
      defaultMessage: "Message Sent",
    },
    messageSentDialogContent: {
      id: "inAppMessages.messageSentDialogContent",
      defaultMessage: "Your message was successfully sent.",
    },
    messagesList: {
      id: "inAppMessages.messagesList",
      defaultMessage: "Message List",
    },
    filterRecentDays: {
      id: "inAppMessages.filterRecentDays",
      defaultMessage: "Recent (Last {day} Days)",
    },
    subject: {
      id: "inAppMessages.subject",
      defaultMessage: "Subject: {subject}",
    },
    clickToNewMessage: {
      id: "inAppMessages.clickToNewMessage",
      defaultMessage: "Reply Message",
    },
    unreadMessageBadge: {
      id: "inAppMessages.unreadMessageBadge",
      defaultMessage: "{count} Unread",
    },
    unreadMessageNotification: {
      id: "inAppMessages.unreadMessageNotification",
      defaultMessage: "You have ({count}) New/Unread Message(s). View message {link}",
    },
    messageSendBtn: {
      id: "inAppMessages.messageSendBtn",
      defaultMessage: "Send",
    },
    fromText: {
      id: "inAppMessages.fromText",
      defaultMessage: "From:",
    },
    toText: {
      id: "inAppMessages.toText",
      defaultMessage: "To:",
    },
    subjectText: {
      id: "inAppMessages.subjectText",
      defaultMessage: "Subject:",
    },
    composeNewMessage: {
      id: "inAppMessages.composeNewMessage",
      defaultMessage: "Compose New Message",
    },
    attachFiles: {
      id: "inAppMessages.attachFiles",
      defaultMessage: "Attach Files",
    },
  },
  websiteMaintenance: {
    technicalErrorTitle: {
      id: "websiteMaintenance.technicalErrorTitle",
      defaultMessage: "Sorry! We are experiencing technical difficulties",
    },
    technicalErrorMessage: {
      id: "websiteMaintenance.technicalErrorMessage",
      defaultMessage:
        "The website is currently experiencing technical difficulties and we are unable to process your request. Please try again later. We apologize for any inconvenience that may have caused. Thank you for your patience.",
    },
    underMaintenanceTitle: {
      id: "websiteMaintenance.underMaintenanceTitle",
      defaultMessage: "Sorry! We are under maintenance",
    },
    underMaintenanceMessage: {
      id: "websiteMaintenance.underMaintenanceMessage",
      defaultMessage:
        "The website is currently undergoing for maintenance at this moment and will be available soon. We apologize for any inconvenience that may have caused. Thank you for your patience.",
    },
  },
  benefitStatement: {
    hdfSubmittedOn: {
      id: "benefitStatement.hdfSubmittedOn",
      defaultMessage: "Submitted On {when}",
      values: {
        when: " ",
      },
    },
    allMembers: {
      id: "benefitStatement.allMembers",
      defaultMessage: "All Members",
    },
    guaranteedCoverage: {
      id: "benefitStatement.guaranteedCoverage",
      defaultMessage: "Guaranteed Coverage",
    },
    approvedCoverage: {
      id: "benefitStatement.approvedCoverage",
      defaultMessage: "Approved Coverage",
    },
    coveredMembers: {
      id: "benefitStatement.coveredMembers",
      defaultMessage: "Covered Members",
    },
    approvedSumAssured: {
      id: "benefitStatement.approvedSumAssured",
      defaultMessage: "Approved Sum Assured",
    },
    selectedCoverage: {
      id: "benefitStatement.selectedCoverage",
      defaultMessage: "Selected Coverage",
    },
    selectedSumAssured: {
      id: "benefitStatement.selectedSumAssured",
      defaultMessage: "Selected Sum Assured",
    },
    selectedOn: {
      id: "benefitStatement.selectedOn",
      defaultMessage: "Selected On",
    },
    underwritingDecision: {
      id: "benefitStatement.underwritingDecision",
      defaultMessage: "Underwriting Decision",
    },
    pendingInsurer: {
      id: "benefitStatement.pendingInsurer",
      defaultMessage: "Pending Insurer",
    },
    pendingCoverage: {
      id: "benefitStatement.pendingCoverage",
      defaultMessage: "Pending Coverage",
    },
    pendingSumAssured: {
      id: "benefitStatement.pendingSumAssured",
      defaultMessage: "Pending Sum Assured",
    },
    pendingAcceptanceFor: {
      id: "benefitStatement.pendingAcceptanceFor",
      defaultMessage: "Pending Acceptance for",
    },
    otherBenefits: {
      id: "benefitStatement.otherBenefits",
      defaultMessage: "Other Benefits",
    },
  },
  charity: {
    title: "We need your help to make the world a little better!",
    statement1:
      "Your company has taken the first step to creating a City of Good by partnering with CXA and the National Volunteer & Philanthropy Centre (NVPC) to help:",
    statement2: "Children with special needs",
    statement3: "Vulnerable seniors",
    statement4: "Families in need",
    statement5: "And 20+ other local charities",
    statement6: "Families in need",
    statementMobile1:
      "Your company has taken the first step to creating a City of Good by partnering with CXA and the National Volunteer & Philanthropy Centre (NVPC) to help 20+ local charities.",
    statementMobile2:
      "You can too, make a difference by donating any unused flex dollars after your policy ends to the charity chest:",
    question1:
      "You can make a difference too by agreeing to donate any unused flex dollars after your policy ends to the charity chest:",
    question1Mobile:
      "You can make a difference too by agreeing to donate any unused flex dollars after your policy ends to the charity chest:",
    option1: "Yes, I will opt-in",
    option2: "Not at the moment",
    question2: "I want my donation to be tax deductible",
    question2Mobile: "If yes, I would you like to be tax deductible? ",
    termsTitle: "By checking “yes”, I agree:",
    terms1:
      "(i) that if I did not utilise all flex dollars in my employee wallet during my policy period for year 2019 and 2020, I authorise CXA to donate on my behalf, my remaining flex dollars[1] (the “Donation”) to Community Chest Singapore (ComChest) through the National Volunteer & Philanthropy Centre (NVPC) – a charity registered under the Singapore Charities Act[2];",
    terms2:
      "(ii) that CXA shall retain an administrative expense equivalent to 5% of the Donation and the remaining 95% of the Donation, after rounding down to whole numbers[3], will be disbursed to ComChest through NVPC; and",
    terms3:
      "(iii) to CXA’s collection, use, and disclosure of my Personal Data (including my full name, NRIC, residential address, email address) to NPVC, Giving.sg and ComChest, for the purpose of notifying me of my Donation amount, verifying my identity, registering my Donation and tax reference number with IRAS in order for me to qualify for a tax deduction, if applicable. This part (iii) applies only if I wish to receive tax deduction. CXA will collect such Personal Data at a later stage via a formal request in writing. Your Donation will be treated as anonymised if you did not furnish your Personal Data for tax deduction purposes within 14 days upon request by CXA. Please note that if your policy year ends after 31st October, your tax deduction will only be recognised by IRAS in the following year.",
    terms4:
      "[1] The Donation will only be successful only if there is a minimum balance of $11 flex dollars in your employee wallet. If the balance in your employee wallet falls below the minimum balance, funds will not be deducted from your employee wallet and/or your Company.",
    terms5:
      "[2] Community Chest is the fundraising and engagement arm of the National Council of Social Service, the national co-ordinating body for social service agencies in Singapore.",
    terms6:
      "[3] CXA will not deduct the difference between the rounded down figure and your remaining flex dollars from your employee wallet and/or your Company.",
  },
  notificationsLabel: {
    id: "Notifications",
    defaultMessage: "Notifications",
  },
  recentNotificationsLabel: {
    id: "Recent Notifications",
    defaultMessage: "Recent Notifications (Last 60 Days)",
  },
  noNotificationLabel: {
    id: "No Notifications",
    defaultMessage: "No Notifications",
  },
  marketplace: {
    marketplaceLabel: {
      id: "Marketplace",
      defaultMessage: "Marketplace",
    },
    productsLabel: {
      id: "Promotional Offers",
      defaultMessage: "Promotional Offers",
    },
    categoriesLabel: {
      id: "Categories",
      defaultMessage: "Categories",
    },
    seeMoreLabel: {
      id: "See More",
      defaultMessage: "See More",
    },
    offerDetailLabel: {
      id: "Offer Details",
      defaultMessage: "Offer Details",
    },
    providerDetailLabel: {
      id: "Provider Details",
      defaultMessage: "Provider Details",
    },
    providerNameLabel: {
      id: "Provider Name",
      defaultMessage: "Provider Name",
    },
    providerRegistrationNumberLabel: {
      id: "Registration Number",
      defaultMessage: "Registration Number",
    },
    providerInfoLabel: {
      id: "Provider Information",
      defaultMessage: "Provider Information",
    },
    showOfferCodeLabel: {
      id: "Show Offer Code",
      defaultMessage: "Show Offer Code",
    },
    emailOfferCodeLabel: {
      id: "Email Me the Code",
      defaultMessage: "Email Me the Code",
    },
    visitMerchantSiteLabel: {
      id: "Visit Merchant Site",
      defaultMessage: "Visit Merchant Site",
    },
    descriptionLabel: {
      id: "Description",
      defaultMessage: "Description",
    },
    termsAndConditionsLabel: {
      id: "Product Terms and Conditions",
      defaultMessage: "Product Terms and Conditions",
    },
    howToRedeemLabel: {
      id: "How to redeem",
      defaultMessage: "How to redeem",
    },
    locationLabel: {
      id: "Location",
      defaultMessage: "Location",
    },
    offerIDLabel: {
      id: "Offer ID",
      defaultMessage: "Offer ID",
    },
    retailPriceLabel: {
      id: "Retail Price",
      defaultMessage: "Retail Price",
    },
    discountedPriceLabel: {
      id: "Discounted Price",
      defaultMessage: "Discounted Price",
    },
    categoryLabel: {
      id: "Category",
      defaultMessage: "Category",
    },
    searchResultsLabel: {
      id: "Search Results",
      defaultMessage: "Search Results",
    },
    searchCriteriaText: {
      id: "Search Offer or Provider Name",
      defaultMessage: "Search Offer or Provider Name",
    },
    byDescription: {
      id: "#By#",
      defaultMessage: "by",
    },
    offersDescription: {
      id: "Offers",
      defaultMessage: "Offers",
    },
    searchNoOffersDescription: {
      id: "No Offers found based on your search criteria.",
      defaultMessage: "No Offers found based on your search criteria.",
    },
    sendEmailOfferMessage: {
      id: "SEND_EMAIL_OFFER_MESSAGE",
      defaultMessage:
        "<p><strong>Offer Code has been sent to your registered email address.</strong></p><p><strong>Pacific Prime CXA are not liable nor responsible for any transactions, omissions, or errors with any purchases made from third-party vendors.</strong></p>",
    },
    sendEmailOfferLimitMessage: {
      id: "SEND_EMAIL_OFFER_LIMIT_MESSAGE",
      defaultMessage:
        "<p><strong>Too many emails were sent for the same offer.</strong></p><p><strong>Please try again tomorrow.</strong></p>",
    },
    visitMerchantSiteMessage: {
      id: "VISIT_MERCHANT_SITE_MESSAGE",
      defaultMessage:
        "<p><strong>You are now visiting a third-party site.</strong></p><p><strong>Pacific Prime CXA are not liable nor responsible for any transactions, omissions, or errors with any purchases made from third-party vendors.</strong></p>",
    },
  },
  enrollment: {
    convertLeaveLabel: {
      id: "enrollment.convertLeaveLabel",
      defaultMessage: "Convert your leaves",
    },
    priceDescription: {
      id: "enrollment.priceDescription",
      defaultMessage: "All prices are quoted in ",
    },
    lastEnrolledBenefitPlan: {
      id: "enrollment.lastEnrolledBenefitPlan",
      defaultMessage: "Last enrolled benefit plan ",
    },
    lastEnrolledSumAssuredPlan: {
      id: "enrollment.lastEnrolledSumAssuredPlan",
      defaultMessage: "Last enrolled sum assured ",
    },
    creditDescription: {
      id: "enrollment.creditDescription",
      defaultMessage: "Credit",
    },
    spendDescription: {
      id: "enrollment.spendDescription",
      defaultMessage: "Spend",
    },
    viewPlanDescription: {
      id: "enrollment.viewPlanDescription",
      defaultMessage: "View plan details",
    },
    openingBalanceDescription: {
      id: "enrollment.openingBalance",
      defaultMessage: "Opening balance",
    },
    utilizationDescription: {
      id: "enrollment.utilizationDescription",
      defaultMessage: "Utilization",
    },
    remainingBalanceDescription: {
      id: "enrollment.remainingBalanceDescription",
      defaultMessage: "Remaining balance",
    },
    overPurchaseNote: {
      id: "enrollment.overPurchaseNote",
      defaultMessage:
        "You have selected <span style='color:#e42434;'>{overPurchased}</span> more than your Opening balance. This amount will be deducted from your salary.",
    },
    yourSelectionDescription: {
      id: "enrollment.yourSelectionDescription",
      defaultMessage: "Your selection",
    },
    availableBalanceDescription: {
      id: "enrollment.availableBalanceDescription",
      defaultMessage: "Available",
    },
    usedDescription: {
      id: "enrollment.usedDescription",
      defaultMessage: "Used",
    },
    overPurchasedDescription: {
      id: "enrollment.overPurchasedDescription",
      defaultMessage: "Overpurchased",
    },
    goPreviousDescription: {
      id: "enrollment.goPreviousDescription",
      defaultMessage: "Previous",
    },
    goNextDescription: {
      id: "enrollment.goNextDescription",
      defaultMessage: "Next",
    },
    previewDescription: {
      id: "enrollment.previewDescription",
      defaultMessage: "Preview",
    },
    selectPlanDescription: {
      id: "enrollment.selectPlanDescription",
      defaultMessage: "Select plan",
    },
    popularDescription: {
      id: "enrollment.popularDescription",
      defaultMessage: "Popular choice",
    },
    defaultAndPopularDescription: {
      id: "enrollment.defaultAndPopularDescription",
      defaultMessage: "Default & Popular choice",
    },
    selectedMembersDescription: {
      id: "enrollment.selectedMembersDescription",
      defaultMessage: "Selected Members",
    },
    reviewYourSelectionDescription: {
      id: "enrollment.reviewYourSelectionDescription",
      defaultMessage: "Review your selection",
    },
    productDescription: {
      id: "enrollment.productDescription",
      defaultMessage: "Product",
    },
    planDescription: {
      id: "enrollment.planDescription",
      defaultMessage: "Plan",
    },
    yourPayDescription: {
      id: "enrollment.yourPayDescription",
      defaultMessage: "Your Pay(Salary Deduction)",
    },
    healthDeclarationNote: {
      id: "enrollment.healthDeclarationNote",
      defaultMessage:
        "The insurer needs to ask you some questions about your health, lifestyle, occupation and family history before approving your selected benefit upgrades. Please complete this health declaration form.",
    },
    healthDeclarationFormDescription: {
      id: "enrollment.healthDeclarationFormDescription",
      defaultMessage: "Health Declaration Form",
    },
    eHDFRequiredDescription: {
      id: "enrollment.eHDFRequiredDescription",
      defaultMessage: "Health Declaration is Required",
    },
    salaryDeductionDescription: {
      id: "enrollment.salaryDeductionDescription",
      defaultMessage: "Salary deduction",
    },
    benefitSelectionSubHeader: {
      id: "enrollment.benefitSelectionSubHeader",
      defaultMessage: "Benefit Selection",
    },
    broughtForwardSubHeader: {
      id: "enrollment.broughtForwardSubHeader",
      defaultMessage: "Brought Forward Points",
    },
    pointsAllocationSubHeader: {
      id: "enrollment.pointsAllocationSubHeader",
      defaultMessage: "Points Allocation",
    },
    reselectBenefitSelection: {
      id: "enrollment.reselectBenefitSelection",
      defaultMessage: "Reselect Benefit Selection",
    },
    checkOutDescription: {
      id: "enrollment.checkOutDescription",
      defaultMessage: "Check out",
    },
    checkOutSuccessDescription: {
      id: "enrollment.checkOutSuccessDescription",
      defaultMessage: "Benefits selection completed!",
    },
    viewBenefitsStatementDescription: {
      id: "enrollment.viewBenefitsStatementDescription",
      defaultMessage: "You can view your coverage in Benefits statement. Thank you!",
    },
    viewCoverageDescription: {
      id: "enrollment.viewCoverageDescription",
      defaultMessage: "View my coverage",
    },
    selectMemberLabel: {
      id: "enrollment.selectMemberLabel",
      defaultMessage: "Select member(s) to be covered",
    },
  },
  otherBenefits: {
    quotedPrices: {
      id: "otherBenefits.quoted",
      defaultMessage: "All prices are quoted in",
    },
    selectionName: {
      id: "otherBenefits.selectionName",
      defaultMessage: "Selection For",
    },
    yourSelection: {
      id: "otherBenefits.yourSelection",
      defaultMessage: "Your selection: ",
    },
    availableBalance: {
      id: "otherBenefits.availableBalance",
      defaultMessage: "Available: ",
    },
    usedBalance: {
      id: "otherBenefits.usedBalance",
      defaultMessage: "Used: ",
    },
    toastMessageSuccess: {
      id: "otherBenefits.toastMessageSuccess",
      defaultMessage:
        "Your selection is complete. You can view your chosen benefits in the Benefits Statement.",
    },
    toastMessageInvalid: {
      id: "otherBenefits.toastMessageInvalid",
      defaultMessage: "Invalid benefit statement.",
    },
    noOtherBenefitsAvailable: {
      id: "otherBenefits.noOtherBenefitsAvailable",
      defaultMessage: "No other benefits available.",
    },
    defaultPlan: {
      id: "otherBenefits.defaultPlan",
      defaultMessage: "Default Plan",
    },
    selectedPlan: {
      id: "otherBenefits.selectedPlan",
      defaultMessage: "Selected Plan",
    },
    members: {
      id: "otherBenefits.members",
      defaultMessage: "Members",
    },
    otherBenefitsNote: {
      id: "config.otherBenefitsNote",
      defaultMessage: "Other Benefits Notes foot note example",
    },
  },
  mentalWellness: {
    id: "mentalWellness",
    defaultMessage: "Mental Wellness",
  },
  surveyNotAvailable: {
    id: "surveyNotAvailable",
    defaultMessage:
      "This page can not be accessed. Please reach out to the contact center for assistance.",
  },
  roleSelection: {
    selectRoleLabel: {
      id: "selectRoleLabel",
      defaultMessage: "Please select your role",
    },
    selectRoleNote1: {
      id: "selectRoleNote1",
      defaultMessage: "You can perform actions limited to the role selected",
    },
    selectRoleNote2: {
      id: "selectRoleNote2",
      defaultMessage: "You can switch roles under the Me menu.",
    },
    staffRole: {
      id: "staffRole",
      defaultMessage: "Staff",
    },
    hrRole: {
      id: "hrRole",
      defaultMessage: "HR",
    },
    continueButton: {
      id: "continueButton",
      defaultMessage: "Continue",
    },
    switchRoleDescription: {
      id: "switchRoleDescription",
      defaultMessage: "Switch Role",
    },
  },
  ofDescription: {
    id: "ofDescription",
    defaultMessage: " of ",
  },
  statementOfAccountDescription: {
    id: "statementOfAccountDescription",
    defaultMessage: "Statement of Account",
  },
  yourAccountBalanceDescription: {
    id: "yourAccountBalanceDescription",
    defaultMessage: "Your account balance",
  },
  meDescription: {
    id: "meDescription",
    defaultMessage: "Me",
  },
  closeDescription: {
    id: "closeDescription",
    defaultMessage: "Close",
  },
  unlimitedDescription: {
    id: "unlimitedDescription",
    defaultMessage: "Unlimited",
  },
  soaCurrencyDescription: {
    id: "soaCurrencyDescription",
    defaultMessage: "All amounts for entitlements and utilizations are quoted in ",
  },
  loadMoreDescription: {
    id: "loadMoreDescription",
    defaultMessage: "Load More",
  },
  returnToAppDescription: {
    id: "returnToAppDescription",
    defaultMessage: "Return to App",
  },
  loginAutoRedirectDescription: {
    id: "loginAutoRedirectDescription",
    defaultMessage: "Your login is completed, you will be redirected to the mobile app in {countdown} seconds.",
  },
  loginFallbackDescription: {
    id: "loginFallbackDescription",
    defaultMessage: "If you are not redirected, please click the button below to return to the mobile app now.",
  },
  expandAllDescription: {
    id: "expandAllDescription",
    defaultMessage: "Expand All",
  },
  collapseAllDescription: {
    id: "collapseAllDescription",
    defaultMessage: "Collapse All",
  },
});

export default messages;



// WEBPACK FOOTER //
// ./components/messagesDescription.jsx